module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM BROOKHART")]), _vm._v(" was driving home from the little town of Buckman when it happened….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HE’D BEEN")]), _vm._v(" visiting his new… well, he wasn’t sure what Shane was at this point. Boyfriend? Could he really be a boyfriend?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam mentally rolled his eyes as he drove through the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nah. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Me?")]), _vm._v(" With a boyfriend? It was to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So what was Shane, then?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had to be honest with himself. It was looking like Shane was more than a roll in the hay. Because Buckman was just over a three-hour drive from Kansas City, and he didn’t even like to drive the fifteen minutes to and from work. That he’d drive three hours to see Shane was saying something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And a half.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was it the sex? Surely not. Yes, things had been dry for a while there, and his right hand (and even his left) had been getting pretty boring. So another human being was (hopefully) better than self-gratification. But if it was only sex, he could find a guy on E-MaleConnect or Grindr in far less time than it took to drive to hicksville Buckman, Missouri.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Of course there was no telling if a hookup from any of those services would be worth it—would be "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("good")]), _vm._v(" sex—or if the guy who showed up would look (anything) like his picture.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So with Shane he knew he had a good-looking man—very good-looking, in fact. (Sometimes just a glance at the man would start the butterflies in Adam’s belly to whirling. How about that?)—and pretty damned good sex too.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But not the best he’d ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane was pretty vanilla, and Adam had had just about every flavor Baskin-Robbins—Ben & Jerry’s too—had to offer and he liked variety. A lot. Yet while Shane wasn’t Raspberry Sinceri-Tea or Bourbon Brown Butter or even Cherry Garcia, Adam had to admit he was very good vanilla. Not the Best Choice or Always Save brands either. Not even Blue Bunny. No. Shane was the very best, Edy’s or Häagen-Dazs or the seven or eight dollars a pint variety—like you got from Glacé Artisan Ice Cream on Main Street—with the little flecks of real vanilla beans.Shane wasn’t very experienced. But what he lacked in know-how, he more than made up with a willingness—hell, an eagerness—to please. He was a quick learner, taking everything Adam taught him in bed and returning it with interest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But it was more than looks or sex. If that’s all he had going with Shane, Adam could still have resisted the guy—especially given how far away he lived.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The thing was, he actually "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("liked")]), _vm._v(" Shane. When was the last time he’d "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("liked")]), _vm._v(" anyone? Anyone he’d had sex with, that was. He had sex with strangers. Friends, the people he liked, he never had sex with. It messed things up every time. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Every")]), _vm._v(" time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So what am I doing?” he wondered aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Am I dating?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Me?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Examine the evidence")]), _vm._v(", he thought, which was something his sister would tell him to do (of course she would). He wiped at his eyes. There weren’t many cars on this long stretch of middle-of-nowhere road, but the ones that did pass in the opposite direction all seemed to have forgotten they had their high beams on. Not exactly a good thing!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Okay.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("First and foremost was that—well, be honest and call it what is was—he was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("seeing")]), _vm._v(" a guy despite a whole passel of reasons why he shouldn’t. Reasons that were always deal breakers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For instance, Shane smoked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam hated smoking. With a passion. He’d never smoked a single puff off a cigarette in his entire life (although he had hit on something else a few times back in college). His parents both smoked, and he’d spent his entire youth going to school smelling like cigarettes, wearing clothes with burns in them (and oh, the teasing), and listening to his mother and father coughing (and coughing and coughing). Sometimes they’d be watching television, and Drew Carey or Frasier would say something funny, and they’d laugh and then they’d get to coughing and wouldn’t (couldn’t) stop. You could forget about hearing at least five minutes of the show. That wasn’t even counting the mornings he’d wake up because his dad was puking in the bathroom from his morning cough.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam hadn’t been the slightest bit tempted to try even one cigarette when the boys in fourth grade tried to get him to join them behind the school.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No way.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had made up his mind by then that not only would he never smoke, but he would never grow up and marry a smoker.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No way.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d worried his whole growing-up life that he’d get cancer from his parents’ secondhand smoke. Why would he subject himself to more worry and fear once he’d gotten away on his own? Adam avoided one-night stands with smokers—they had to be really hot to get him in the sack—let alone anything more serious than that. Kissing a man who smoked was like licking an ashtray. Horrible. He’d told one-night stands they had to brush their teeth if they wanted to get it on. He kept extra toothbrushes in his medicine cabinet for just such happenstances.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And yet Shane smoked. But then again, he was a very considerate smoker. He always smoked outside, even when they were at Shane’s house. Never in the car, either Adam’s Subaru or Shane’s own pickup. Of course Shane’s clothes still smelled like cigarette smoke, which brought back some pretty bad memories. But—and Adam found this adorable and endearing—Shane kept a little bottle of spritz breath freshener on him at all times and used it regularly, even devotedly. And brushed his teeth if they were at home. You had to give him credit for that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because I hear that kissing someone who smokes is like licking an ashtray,” Shane had said early on. Then looking at Adam, green eyes sparkling, that little smile of his tugging just the left side of his mouth, he added, “And that’s not what I want you thinking about when we kiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had immediately laid the man.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh, and then, good God, Shane liked "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("baseball")]), _vm._v("! Something else Adam had put on his list for immediate elimination in allowing a man to go from a fuck to anything more serious, even a fuck "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("buddy")]), _vm._v(". Adam hated sports. Another chokehold from his childhood. His father "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("loved")]), _vm._v(" sports. All sports. Baseball. Football. Basketball. Hockey. Christ, he even loved bowling and golf. And as Mark Twain once said, “Golf is a good walk spoiled.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s mother had been a sports widow. He and his mom had spent endless hours either in the kitchen baking something or in the garden or listening to books on tape while she sewed and while his father and his sister sat on the couch watching one type of game after another. Sometimes as many as two or three games in one day!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had sworn he and his kids would never be relegated to other rooms, widowed and ignored by his wife, while endless hours of sports played on the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But then somewhere along the line, the idea of getting married and starting his own family changed as he realized he was gay. Along with the idea of settling down with anyone. The thought of opening himself up to someone’s whims became ugly and suffocating.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So what did he do?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why, he’d spent the last six weekends with a man who loved baseball. Baseball, of all sports. At least with football it was only around a dozen games in the fall and winter (he wasn’t sure and didn’t care). Baseball had over a hundred and fifty games in a season!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Yet he’d even gone to a baseball game with Shane—the Kansas City Royals versus… well, he wasn’t sure—and what was wild was that he’d had a pretty good time. Of course he figured that was mostly because he liked Shane’s company, the beers, and the excitement of the crowd more than watching men hit balls with sticks and then run around in circles. At least it was only baseball. Not basketball, and certainly not the ruination of a good walk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Speaking of Mark Twain, Shane wasn’t a big reader. He’d read Dan Brown’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Da Vinci Code")]), _vm._v(", and Adam had seen the Max Brand and Louis L’Amour novels next to his bed (and the toilet of course—he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("was")]), _vm._v(" a man). Oh, and some Destroyer novels. Not exactly what Adam thought of as the best reading material.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But thinking about that, at least Shane "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("did")]), _vm._v(" read. Adam had to be fair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he wasn’t one of those goons who wondered why Adam loved to read. He even picked up some books for Adam at garage sales, good ones too, like the newest by Daniel Woodrell and Frederic Tuten, which Adam had been waiting for his bonus check to buy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So the bottom line was, Adam couldn’t figure out why he was breaking all his rules when it came to Shane, why he was keeping this up, seeing him weekend after weekend. Examining the evidence wasn’t helping.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vanilla sex (even good vanilla sex), cigarettes, sports, and a lack of good reading, were all enough, separately, to make him push Shane Farmer away. Like the magnets he used to play with when he was a kid. Slide one toward the other one way, and some kind of invisible force would push the second one away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But flip the magnet over so the poles were reversed, and the other would zip over and—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("click!")]), _vm._v("—they would stick together.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was just like that. Something had “flipped” him over, and instead of pushing Shane away, he kept zinging toward him. And "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("click!")]), _vm._v(" They were together once again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He still felt it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head and marveled at the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d felt it Friday night when he’d gotten to Shane’s house. Shane had opened his door, and it was like Adam’s chest was yanked toward Shane’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d kissed Shane right there on the back stoop, and Shane had responded—for just one moment—and then gasped, pulled away, grabbed him by the lapels with both hands, and yanked him inside.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They’d had sex on the kitchen floor. And over the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh, and that tug at Adam’s heart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat up straight in his car seat. Almost wove into the other lane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Goddamn.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His sister would fall out of her black, but sensible, shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Am I…?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THAT WAS")]), _vm._v(" when it happened.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("UGH….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The car swerved.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat bolt upright.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something wasn’t….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What…. What…?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d been thinking about something. Wondering about something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And now?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now he couldn’t remember what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was as if a shadow had passed in front of Adam’s eyes. No…. Not a shadow. More like a nodding off and…. Well, no, it wasn’t like that either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam, like most of the other seven billion people on Earth, had dozed off behind that wheel at some time or other, and this wasn’t like that either. Hell, he’d actually fallen asleep driving once. He’d been coming home from college after taking the last of his finals. He had been by himself. His friends had all finished a few days before, but he’d had his last one on Friday when they’d been done by Wednesday. He’d spent a number of late- or all-nighters studying. His grades had slipped a little, and he’d wanted to do far more than pass his tests: he’d wanted to ace them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One minute he’d been driving, and then there was a big bump and his eyes had flown open and sunflowers were flying over the hood and windshield while a sea of bright yellow flowed by him on the left and right! He had fallen asleep and driven off the road and right through a field of big, insanely tall sunflowers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank God it hadn’t rained in days. The ground was dry, and when he slammed on his brakes, he didn’t harm the car or get stuck. It was only when he backed up that he saw how lucky he had been. He had missed plowing into the guardrail edge on by a mere couple of feet, and since he hadn’t been wearing his seat belt, he’d missed dying by the same distance. He’d worn it religiously ever since then. He also made sure never to drive when he was sleepy again. Better to stop at a rest area and nap for an hour or three.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. He hadn’t fallen asleep. It wasn’t like that. Didn’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("feel")]), _vm._v(" like that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So this “happening” wasn’t a shadow (how could it be; it was night after all?) and it wasn’t nodding off, and it as sure as hell wasn’t falling asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What, then?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam passed a sign that reported Kansas City was only seventy-six miles away, and his mouth fell open. Good God. Seventy-six miles? What the hell?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Had he gone into some kind of trance?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Only explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The oncoming headlights—with their officious high beams—had hypnotized him. He’d zoned out. Lost time. Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He must have lost a good hour. He couldn’t remember ever having done something like that before.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or could he? Was there some niggling little thought…?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head. Banished it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He glanced at his fuel gauge and judged he should be okay. He could always stop in Terra’s Gate, which should be coming up soon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Wow. Wow, had he lost time. He couldn’t even remember what he’d been thinking about.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Weird.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HE CALLED")]), _vm._v(" Shane as soon as he walked in the door. It was their deal when one of them left for home as late as they usually did. Just an assurance that they’d made it home safe. Shane was the one who had really insisted on the practice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("How sweet was that?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam did not get the response he was expecting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dammit, Adam! What took you so long to call? I was worried sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam blinked in surprise. Shane yelling? He hadn’t heard him raise his voice yet. When he wasn’t having an orgasm, that is. What was he yelling about?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane… I just got home. Called you first thing.” What was Shane talking about?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam! It’s two in the morning!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam froze.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bullshit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He swiveled around to face the VCR in his entertainment center. And there it was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("2:06 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His eyes went wide, his jaw clenched, he couldn’t speak. A feeling of dread fell over him, and he had no idea why.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam? Are you there?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, Shane. I’m here. I….” I what? He’d left Shane’s at just after nine. They’d just not been able to get out of bed. That meant he should have been home around midnight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was two in the morning. Six minutes after, that was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hon? Did you stop somewhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” he said. But he must have. Had he pulled off the road and fallen asleep, hypnotized by the oncoming headlights? Then he admitted it. “I don’t know, Shane.” Maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was Adam’s turn to ask. “Shane?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” came the answer. “I’m with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam gave a laugh. Okay. Time to let reason assert itself. “I’m sorry to call you so late, babe,” he said, and then he froze again. Had he just called Shane “babe”?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sat down on the arm of his couch. Took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane, I don’t know what happened. I think maybe I fell into a trance or something.” Then reason really did assert itself. “I’m sure that’s what happened. I bet I was sort of out of it—it’s not like we got much sleep this weekend.” He laughed again and to his surprise felt his cheeks heat up. “I went into la-la land and started driving really slow, maybe. I should count myself lucky I didn’t get pulled over.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Silence again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry I yelled,” Shane said. “I was just worried is all.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Worried.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Somebody worried about him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Somebody besides his sister, that was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was nice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A sudden memory hit him all at once. Sitting up straight in his car, hands clenched on the wheel, and wondering if… "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("if I’m falling for Shane")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When had that happened?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For some reason the thought sent a shiver through him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He took a deep breath. “You need to go to bed, Shane.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re the one that needs to get to bed, hon,” Shane replied. “You have to get up in like three hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Except Adam knew right then that wasn’t going to happen. He’d call in. He needed the sleep. He was tired. Very tired. Exhausted even. And it wasn’t like he and Shane had had "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("that")]), _vm._v(" much sex. They’d watched TV in bed. They’d slept in. Gone to a little breakfast place run by a sweet old couple that served good home-cooked meals like he remembered his grandmother used to make. They’d hung out in Buckman’s little park, and Saturday, they’d spent an evening at a carnival. Even ridden the Ferris wheel together. Adam had grabbed Shane’s hand at the top. He wasn’t too crazy about heights.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why should he be so tired?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam? Go to bed. I’ll see you this weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Right?” came the question.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded. “Sure. Of course.” Why not? Then: “Think I’ll stay up just a bit more. Think I’ll have a cocktail first. My mind is whirling.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You going to be able to get up and go to work?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Think I’m going to skip work tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They won’t get mad?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fuck ’em if they do,” he replied and they both laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay. Guess I’ll sign off. I lo—” Shane paused. “—loved having you here this weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It was nice,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another pause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You sure you’re okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure,” Adam said and headed to the kitchen to make that cocktail. He had some Crown. That would be good. Drink it slow. “Why shouldn’t I be okay? So I zoned out. Like I said, you did me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just thinking,” Shane replied. Except his tone was funny.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam was pulling the bottle of Crown out of the freezer. He liked it very cold. “Thinking about what?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh… nothing to worry about. Maybe we can talk about it this weekend?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Talk about "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("what")]), _vm._v(" this weekend?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was it going to be the “where are we going with this” conversation? He whirled the cap off the bottle and took a good heavy sip. Then another.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes, Shane,” he answered, and took another drink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t worry about it, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded and decided to take Shane’s advice. Not worrying. Sounded like a good idea. He took a fourth drink. This one a good healthy swallow. The others had prepared him for it. So it went down smooth, cool, and then generated heat deep down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay,” he said. “I won’t worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good night.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good night,” Adam said and found himself almost saying something else.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And heard that echo in his head again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Am I…?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he wondered why he couldn’t remember what happened after that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He took the biggest drink yet, and then the ice and fire spread through him and he did stop worrying about it. “See you this weekend, babe.” And yes, he said “babe.” Why the hell not?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“This weekend,” Shane repeated, and this time if there had been anything funny in Shane’s voice, it was gone. It was warm again. All good.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was that little "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("bip")]), _vm._v(" as the line went dead, and Adam took the bottle of Crown back to the living room and, doing his best not to look at the time, switched on his television and turned it to Netflix. Found something fun. Nothing spooky or weird or thought-provoking. Stand-up comedy. John Mulaney—that could be good. No. Jen Kirkman. She was funnier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Funny was good.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He fell asleep on the couch.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he had strange dreams…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(Faces)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("…that he didn’t remember the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM MET")]), _vm._v(" his sister for coffee at The Shepherd’s Bean the next morning, late. It was usually a Saturday morning ritual for them, but one they hadn’t kept since he’d been spending his weekends with Shane. Thank God her work partner, Townsend, wasn’t with her. The guy creeped Adam out. He was mean, although Daphne swore he was a pussycat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam beat her there, but he didn’t order for them because there was nothing worse than cold coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He needn’t have worried. She got there less than five minutes after him. Thank God she was smiling. He’d been prepared for a big grilling on the reason(s) they hadn’t seen each other in a month and a half. She was wearing one of her smart little suits—blouse and slacks and a short jacket—as she had ever since she’d become a detective. The way she dressed for work was the closest to feminine attire he’d seen her wear since she escaped their parents’ house. No more blue uniforms either. He didn’t miss them. He’d never cared all that much for cops, so leave it to his sister to become one. Could the two of them be more different? At least she didn’t smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Morning, Daph,” he said. He was pretty much the only person on the planet who could get away with calling her that. She didn’t let her partner call her Daph.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Morning, Adam,” she said after one of her rough hugs. “You check the menu?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He nodded. “There’s a couple of Colombians. You like that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She returned his nod. “I like everything here,” she told him. Which was true. This had been her “spot” ever since she’d come in here a couple years back while on duty. She’d quickly found she liked the people who worked there—several of whom were gay—and liked the coffee as well. He also suspected she had a bit of a crush on the young lady with the big glasses, but sadly (for his sister), she was quite happily partnered with the lady who ran the no-kill animal shelter around the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne went to the counter, and sure enough, the young lady took the order. His sister hadn’t asked what he wanted, which was her all over. Hopefully she remembered he didn’t usually care for Colombian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daph looked over her shoulder. “Want a doughnut? They’ve got the pistachio ones you like so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That made him sigh happily, and he told her he would love one. If she remembered his doughnut, surely she would remember the coffee preference. She was a police detective after all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He picked a table with two seats. A few minutes later, his sister sat down across from him and placed a little plate with a doughnut with light green icing on it in front of him. She had one too, but hers was plain. No surprise there.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Our coffees will be here in a minute or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which he knew. He’d been here enough times with her. She was just filling the air with words.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Not asking him where he’d been? Why he’d been ignoring her?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I like the beard,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He reached up and touched his face, still surprised at its presence. He had kept his facial hair in that “I haven’t shaved in a couple days” style for years. But Shane liked men with beards. Said men with beards were the hottest. Said he was jealous of men who could grow them, and it took him a month to get a five-o’clock shadow. And he liked the way it felt on his thighs and… other places.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God. No one had ever licked Shane’s ass! Adam couldn’t imagine how anyone could have resisted. Shane had a beautiful ass. So high and round. And the hair that ran down his….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m guessing the Colombian is yours,” came a voice, and they turned as one to see a handsome bald man with a beard of his own serving them their coffees. It was Dean, aka “Bean,” the owner of The Shepherd’s Bean. He was placing a cup of coffee in front of Daphne. “And the Papua New Guinea is yours?” He set the second one before Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("And I questioned for even a moment that my sister would know what I want?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Perfect,” they both chorused.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Their selections came with about an extra cup’s worth of coffee in a beaker. He’d never understood why it was in a beaker.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("With a smile Bean nodded and headed back to the front counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Avoiding Daphne’s eyes, Adam blew on the surface of his coffee. It smelled wonderful. He tasted it. Nice. Really nice. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Not")]), _vm._v(" his mother’s coffee. Not Shane’s either. Shane could drink instant coffee. God! "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What am I doing with that man?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So what’s his name?” Daphne asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Whose name?” Adam asked automatically and then blinked at his own answer. Shane’s of course. But how could she know that?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Police detective, dummy!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("But she can’t know.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She raised a perfect eyebrow that any other woman would have died for (or waxed for at least).")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” he snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her other brow joined the first, and she took a drink of her coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stared down at his own. Took a drink. Tried to ignore her. But that was stupid. She was sitting right across from him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked up at her. He saw a twinkle in her eyes. Suddenly he was blushing, and of course that gave him away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wow,” she said and smiled. “Who would have ever thought it? My little brother has a boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not a boyfriend,” he replied, quickly and with a little too much force.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then he must be a hell of a fuck buddy if he’s taken you away for nearly two months.” She ran a finger through her short dark almost-curls, then looked at her nails—a silly gesture since she never did a damned thing with them. That would have been way too “fem.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He decided to go with it. Go with the flow. Why the hell fight it? “Jealous?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne gave a half shrug—a gesture he’d seen his entire life and that was as familiar as anything about her. “Maybe,” she answered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Really? She admitted it? Would wonders never cease?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane,” he said, answering her original question, and was amazed he’d done it. Actually said Shane’s name—just like that. As casual as could be. Today was not supposed to be about that. Today was seeing his sister because he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("could")]), _vm._v(" and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("she")]), _vm._v(" could. It was about catching up. Of course, how could they do that if he didn’t talk about Shane?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But what was there to talk about?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That brought Shane’s green eyes to mind and his cute smile that often lifted one corner of his mouth, and Adam felt a tingle in his belly he couldn’t explain. He’d never really felt anything like this before, unless he included the huge crush he’d had on his friend Buddy back when he was in junior high school.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And?” Daphne asked and took a big bite of her boring doughnut.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He followed suit, but with his far better doughnut, and made it a big one so he could avoid answering her, even if for only another moment. The truth was, he didn’t know what to say. He was truly mixed up about all this. Wondered why he even now couldn’t wait to see Shane again. Wished maybe Shane was here with him so his sister could meet him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His eyes widened at the realization.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Whoa.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Really?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You okay, Adam?” his always perceptive sister asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He jerked and nearly spilled hot coffee on his hand. “Fine….” Adam didn’t look at her face. And he wasn’t sure why.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now he looked up. There was concern in those deep dark eyes of hers. “You sure you’re okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He let out a long, long sigh. “I am, Daph.” He took another drink of his coffee. “It’s just weird. I mean… I think… I think I like this guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A radiant smile took her face. “Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He couldn’t help but smile back. “But it’s weird. Sometimes it’s like those butterflies I hear people get all the time. And then sometimes I think I could puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her expression was a strange half grin, half grimace. Then she gave a short, fast nod. “I get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She did? “You do?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course I do. I am a Brookhart, aren’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like that means anything,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’re more alike than you’re ever going to admit,” came her quick retort.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head. Them, alike? Besides both having the same parents and both being queer (and hadn’t that been an interesting happenstance, especially to their parents), Adam couldn’t imagine them being more different.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne put an elbow on the table and propped her chin in her upturned hand. “Seriously, though. I’m interested, little brother. How’d you meet this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He smiled. “You should know. You were there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She looked at him blankly. “I was?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup. It was at Gay Pride this year.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She paused, mulled it over for about ten seconds, and then one of those perfect eyebrows shot up. “Not the cutie you had share your blanket?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now he was grinning foolishly and knew he must be blushing. “One and the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("7")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE GUY")]), _vm._v(" looked like he was lost. Or terrified. Or maybe like a kid at the gates of Disney World.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam was leaning back on his elbows on his blanket in the grass, watching some drag queen up on stage lip-syncing to Blondie’s “Rapture.” He was drinking a beer when he noticed the cute guy standing about ten feet away. He looked to be in his late twenties, and damn "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("was")]), _vm._v(" he cute. With dark blond hair cut short and what appeared to be blue eyes, he was wearing plaid shorts and a dark blue T-shirt, and he had his arms crossed over his chest. Adam found himself staring.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Right then the strangest thing happened. He heard a long, high, piercing noise in his head that made him wince—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hurts!")]), _vm._v("—and just as fast as it started, it was gone, leaving a slight achy echo behind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You okay?” It was Daphne, and she was sitting next to him. In shorts of all things. His sister! In shorts.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam rubbed at his temples with one hand, muttered an “I’m okay,” and noticed that cute guy was grimacing. He was rubbing at his forehead, and then he turned and looked straight at Adam. Their eyes locked, and Adam felt a distinct chill, despite the bordering-on-excessive heat of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It passed as quickly as it had started, faster even than the ice pick to his brain a few seconds earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They each continued to look at the other.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s stomach clenched. He didn’t know what to say. He never knew what to say. But somehow he knew, just knew, that if he didn’t say something, this guy was going to walk away, and he didn’t want him to walk away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He raised a hand, still leaning back on his elbows, and managed a “Hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shakespeare would be so proud.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The guy blushed—Adam could see it from here—and managed a “Hi” of his own. He bit his lower lip and started to look away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Say something!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then the guy was doing more than look away. He was moving.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Say something, idiot,” Daphne said, voicing his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ah… having a good time?” he called out. Or tried. It was more a croak than a question.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The guy looked back. “Wh-what?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I….” Adam cleared his throat. Then louder, “Having a good time?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam got a nod in return, and then a big shrug. “I guess. I’m so nervous I don’t know what to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat up. Gestured for him to come closer. “What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane,” came the muffled reply.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What are you so nervous about?” Adam smiled, his stomach twisting now. This wasn’t what he did. But for some reason, he couldn’t help himself. There was something about this guy—this Shane. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Close.")]), _vm._v(" He motioned for the man to approach. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m not going to hurt you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane took a step. Then another. “I….” He looked away. Looked back. “I’ve never been to anything like this before.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Pride?” Adam asked, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?” And then he wondered why he was asking that. It was obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tell him your name,” Daphne said from behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam,” he blurted. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Stupid!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Huh?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“My name. It’s Adam.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh!” Shane blushed even harder. “Duh. Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Invite him over,” hissed Daphne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Invite him over? God. But then, didn’t that sound like a good idea? Wasn’t that the old point-a-roono? Adam took a deep drink of his beer, almost finishing it. For strength. Then he patted the blanket next to him. “Want to join us?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane hesitated a moment and then with a shrug sat down right where Adam had patted. He had nice legs, with just the right amount of hair. In fact, Shane had nice everything. Up close his eyes turned out to be hazel and bright and, well, beautiful. He was still blushing, and one corner of his mouth was twitched up in a cute sort of half smile. His hair was light brown rather than dark blond—a distinction Adam couldn’t figure out why he was noting. He liked the way it shone in the bright sunlight, though. And he liked the way Shane smelled. Like lavender soap and just the littlest bit of clean sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m gonna go for a walk,” said Daphne, and then she rose up in that graceful way of hers. “I’m Daphne, by the way.” She did a little wave and disappeared into a crowd of leather men and cowboys.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I didn’t do something to make her go away, did I?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” Adam replied. “She’s probably going to look for her lesbo friends.” Shane twitched at that word, and Adam immediately regretted saying it. Had no idea why he had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nervous. I’m so damned fucking nervous!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His stomach felt like it was full of cast iron.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m so damned nervous,” Shane said, echoing Adam’s silent words.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because you’ve never been to anything like this before?” Adam gestured with his whole arm, taking in everything around them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded once in response.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you gay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” Shane whispered and then gave a little gasp, looked back with an expression of surprise. Like he couldn’t believe he’d said it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was charming. Utterly charming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me too,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good,” Shane said in a tone that was barely louder than before. Turned red again. “She’s not your g-girlfriend, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam dropped his head back and laughed. “God, no. She’s my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really? You two don’t look a thing alike.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ve heard that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m glad she’s not your girlfriend.” Now he was crimson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The iron in Adam’s stomach went away, and now there were butterflies there instead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” he said, now as lightly as Shane. Could he be heard over the drag queen—the faux Blondie—singing about the man from Mars eating up cars?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Apparently, he could. “Why?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why are you glad she’s not my girlfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m glad you’re gay.” Adam saw him swallow. Hard. “Because you’re so handsome.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me?” Adam grinned. “You’re the good-looking one.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me?” Shane was becoming a regular echo.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam reached out to touch Shane’s cheek—Shane gave a quiet gasp—and stopped himself. God. Shane wasn’t a virgin, was he?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked a little scared. Or lost. Excited? Or maybe all three, because wasn’t that what it was all about when a kid was waiting to go into the Magic Kingdom?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now Adam’s heart was racing. Excited himself. They were so close.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For a second there I thought you were going to kiss me,” Shane said and laughed, and the sound made the butterflies in Adam’s stomach begin to shift their wings.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You want me to?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gulped again. “Not yet.” And the only reason Adam heard him was that the drag queen’s song had come to an end.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The butterflies were aswirl.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then they went away. Shane pulled out a pack of cigarettes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fuck.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mind?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And what was he supposed to say? Not only no, but fuck no?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Hardly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head. All thoughts of kissing were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane surprised him then. He lit the cigarette, took a deep draw, and then held it out to the side, making sure the smoke didn’t blow in Adam’s direction on the breeze—such as it was. He blew the smoke carefully as well. He didn’t even finish it but stabbed it out in the grass when it was only about half done. And that was when he pulled out the little metal bottle from the same pocket the pack of Wildhorse 100s had come from—Adam had never heard of that brand of cigarettes before—and, pushing a little button on top, shot two mists of mint into his mouth. Breath spritz. Adam smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry. I’m just so damned nervous.” He bit his lower lip.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam took a deep breath and let it out slowly. Well, well. A courteous smoker.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And when Shane released his lip… it looked so kissable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They locked eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The butterflies were back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I love your beard,” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Beard,")]), _vm._v(" Adam thought. It was only a few days growth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It looks soft. Is it? I can’t grow a beard. Not for anything. Can I tou—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You boys thirsty?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They both jumped and looked up and saw Daphne standing over them, holding three cups of beer in translucent cups.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam grabbed the cup he’d been drinking from before, swallowed the little that was left inside, and reached for one of the new beers, sliding the new cup inside the empty one.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane? Do you drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do. Especially now!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane took one of the proffered cups and swallowed deep. Wiped at his mouth with his arm. The wet matted down the soft hair that grew there.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was hard not to reach out and gently wipe it off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So what about those Royals?” Daphne said, breaking in on the moment, and then folded herself down magically onto the picnic blanket yoga style.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane perked up and grinned. Full smile and not his cute little half one.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my God, did you "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("see")]), _vm._v(" Sunday’s game?” he cried. He looked back eagerly between Adam and Daphne. He was actually wiggling with excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course,” Daphne exclaimed. “Could you believe that infield homer that Eskie hit?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And Wade Davis? That guy’s ERA is 1.11! He’s practically unhittable!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes! And how about Salvy’s great snag at home? Kept them Sox in check!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hell yeah! Our boy saved the game.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It degenerated after that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Sports. Good God. He likes sports.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Daphne Brookhart, family detective extraordinaire, didn’t notice a single one of the looks that Adam was directing at her, not one gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But then Shane managed to do something that Daphne couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Notice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey,” Shane said quite suddenly, turning from Daphne and looking at Adam with those sparkling eyes. “I just realized something. I haven’t seen anything around here yet. You want to show me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then that quirky half smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure. I’d like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It looks like there are some booths. What kind of stuff do they sell here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam laughed. “Oh…. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Stuff")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Some of it I don’t think you’ll believe.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And funnel cake,” Shane said with a grin. “I’m sure I smell funnel cake.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But it’s so sweet I can never eat it all. Want to split one?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sounds delightful.” Now Adam couldn’t help but smile. Shane was utterly charming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The butterflies were back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("SHANE CAME")]), _vm._v(" to Kansas City that weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a good thing. Because after Adam’s strange trip home, he knew he wasn’t driving to Buckman. Not for love nor money.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or even one of Shane’s sexy smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had been having dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was driving. There were long dark night roads. Roads that went on and on and on and never seemed to stop. And then blue light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d woken up at least one night shouting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Despite that, they had sex about three minutes after Shane walked in the door of Adam’s apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They didn’t fuck. They hadn’t yet. Which Adam thought was a little weird—all these weeks and no fucking? Adam couldn’t even figure out why. He liked to fuck. Sometimes he liked to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("be")]), _vm._v(" fucked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(rarely)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But with Shane?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane just couldn’t. And the one time they had almost tried—that had been a few weeks before—with Adam climbing on top of that beautiful ass, carefully and slowly working his way inside of him, Shane couldn’t go through with it. Shane had never been topped. He’d said he thought he could do it with Adam, but it had all fallen apart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d actually been crying. “I can’t. I. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Can’t")]), _vm._v(". I just can’t let anything…. I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had been their worst moment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A total disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay, Shane,” Adam had told him and moved so they were face-to-face and held him close.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Disaster had been averted, and after some quiet cuddling and a little kissing, the lovemaking had resumed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Lovemaking.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Whoa.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And today, when Adam had opened the door and saw Shane standing there, he felt a rush like he couldn’t ever remember feeling before. And whether it was lust or hormones or something he’d never expected to experience, he quite desperately needed Shane. He’d kissed him right there on the threshold, and this time witnesses be damned. This was Kansas City, not Buckman, and the apartment building was called the Oscar Wilde, and nearly all its residents were gay, lesbian, transgender, or queer identified, so who was going to care?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("almost")]), _vm._v(" resisted there for a second or two and then—perhaps realizing just where he was—accepted and returned the kiss and then practically melted against Adam. He had an erection. Adam could feel it (against his own). And God. An erection was a terrible thing to waste.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Besides, the lasagna was in the oven, and it still had almost an hour to cook. There was time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It wasn’t like they took long. The lust was way too much a part of it. They did manage to get over to the couch. In no time they were both face to crotch and urgently making love to each other with their mouths, and Shane smelled so damned good—that combination of clean road sweat and lavender soap—and they came at almost the same moment. Adam swallowed hungrily. Shane did too, and that was nice because it was some small-town taboo Shane had been trying to overcome for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When they switched over so they could cuddle close, Shane said, “Nice appetizer,” and Adam couldn’t help but laugh. Couldn’t help but feel the delightful flutters in his stomach once again—and maybe even a few of those butterflies had risen to swirl around and light on his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It should have terrified him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had to bite his lip (like Shane was always doing, but much harder) to keep himself from saying it right then. From using the L-word.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And it wasn’t “lesbian.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh my God. Is it happening? Am I falling for this guy?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The timer went off in the kitchen, surprising Adam. Had it been an hour? How could it have been an hour? Had they been cuddling that long? It didn’t seem possible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He disentangled himself, despite Shane’s grumblings, and went to the kitchen still naked. Shane whistled after him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wiggled his ass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave him a catcall.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was nice. Adam went into the kitchen grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He opened the oven and the aroma of the lasagna, which had been wafting out to them already, hit him full force, along with the roll of heat. It smelled wonderful. He actually started salivating. Carefully he pulled the tented foil cover off the store-bought container—the cheese was bubbling beautifully—closed the door, and then set the timer once more. This is where everything browned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Adam felt something against his ass, and he jumped and turned and was pulled into Shane’s arms. The “something” was Shane’s newly revived cock.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dinner,” Adam managed to say, feeling himself growing hard. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God, he gets me hard again that fast….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You just shut the oven door.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Only ten more minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We could do a lot in ten minutes,” Shane said. He had come so far from the blushing guy at Gay Pride. The one who had only had sex with a few men in his whole life. Not a virgin. But close.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I want to take my time this time,” Adam whispered and kissed his lover.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("My lover. Wow.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane sighed. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Want to help me with the garlic bread?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know I can barely boil water.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You grill like a chef.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave him that half smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All you have to do is pop it in the oven. It’s in the freezer.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sounds easy enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll finish the salads,” Adam said and opened a cabinet, got on his toes to grab the bowls.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane grabbed his ass. “I can’t wait for dessert.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked over his shoulder and saw the hunger in Shane’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He thought he might just let Shane have some.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I must be in love.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("9")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM WASN’T")]), _vm._v(" expecting what he found the next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had gotten up first, although that wasn’t abnormal. Shane was a “morning person.” Another big difference between them. Shane had been working a shift that started early for ten years. He couldn’t sleep in even when he didn’t have to work.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What was unexpected was the books on the table. The books and the journals. Shane with books? So many of them? Shane had one open and was writing in it when Adam walked in. He looked up, a funny expression on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Even from where he stood halfway across the room, Adam saw the word UFOs in stark white on the dark cover of one of the books. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shivered. He didn’t know why.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He laughed. It was an uncomfortable laugh. “What… what are you doing?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another shiver.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked up at him and instead of laughing and saying something like, “Ah, damn! You caught me! I’m a bigger geek than you ever knew—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(And he should have known because Shane liked all those shows about Bigfoot and the Bermuda Triangle and the shooting of President Kennedy.)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—he said, “You know what I’m doing, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t know. He shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane let his head fall to the side and sighed. He looked down at the coffee table and the books and removed his splayed fingers from the journal he’d been writing in. It slipped closed. Shane had been writing on one of the early pages. But there were at least a half dozen more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam took another step. He could see some of the book titles clearly now. One of them had a mostly white cover with the title "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Captured!")]), _vm._v(" in blood red. There was one he’d seen already—the cover was a darkened sky and the title was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs Caught on Film")]), _vm._v(". Then one he’d seen at a hundred garage sales—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v(". "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh, fuck me…. ")]), _vm._v("Another said "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Alien")]), _vm._v("—something something. He couldn’t see the whole title. His stomach was doing funny things, and he didn’t know why. He did know he didn’t give a shit what the rest of the title was. Or the complete title of the pocket-sized paperback on which the only words visible were "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Interrupted")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shivered once more. But he grinned. Tried to make light of it. And why not? Why shouldn’t he? What was the big deal?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“UFOs, Shane? Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded. Patted the space on the couch next to him. Adam found himself reminded of that day when they met, him patting the picnic blanket, bidding Shane to sit with him. Shane had done so, eagerly. But somehow it was not what Adam wanted to do right now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("10")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM HAD")]), _vm._v(" been pleasantly surprised when Shane went home with him from Pride. He’d been so sweet. So… shy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is the kind of guy I’ll have to date at least three times before he’ll go to bed with me")]), _vm._v(", he’d thought more than once that day. So surprise, surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d shown Shane around as requested. They’d played a few games—Shane was very good, even won a stuffed animal. They visited the booths, and they’d each bought a T-shirt. It was hot when Shane had peeled off his shirt so he could try a few on. Shane had a smooth chest—Adam liked smooth-chested guys, had never been into the hirsute pursuit—with only a fraction of a happy trail that started at his navel and disappeared into his blue-and-white plaid shorts. It had taken Shane a while to pick a shirt. He wanted something gay, but not too gay. Something that he would know the meaning of, but the average shopper at the Super Walmart wouldn’t. Something that he might—repeat, might—be brave enough to wear in the little town where he lived—someplace Adam had never heard of called Buckman, about three or so hours away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The pink triangle, then,” Adam had advised.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Pink triangle?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. I bet even people in Mayberry have heard of the rainbow flag. But most people don’t know about the pink triangle.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had blinked at him. “I don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Voilà! See?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s gay?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They looked into each other’s eyes and once again Adam was feeling funny, mysterious things. Guys were a source of getting off. He either ignored men, or he got into bed (and out of bed) as fast as humanly possible. He didn’t feel funny and mysterious things for men. Because that might mean you could feel other things and let your guard down, let the walls down, let them see parts of you that people had no business seeing. And God, the way Shane was looking at him! It was so sweet and… puppy dog.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t do puppy dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But one look from those hazel eyes and Adam was opening up. Being much more than just superficial.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“World War II,” Adam answered. “There were more than Jews put into the concentration camps. Gypsies. Polish people. And us gays. The Jews wore yellow stars of David. They put pink triangles on the homosexuals. This guy named Larry Kramer helped turn the pink triangle into an activist symbol for gays. But he turned it upside down. So it was pointed upward instead of down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Damn” came Shane’s response. Too much? Had the history lesson been too much?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane took a deep breath. Then he’d set his shoulders high. “Sounds fucking awesome.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam hadn’t been so discreet. He’d picked a shirt that said Read My Lips and pictured two sailors kissing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("How cute had it been that Shane had blushed?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They’d looked at rescue services too, where Adam had discovered that Shane was a cat person instead of a dog person, but he was looking more at the dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dogs bark,” Shane had said, all mysterious again. “Sometimes that’s all it takes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s all it takes?")]), _vm._v(" Adam wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They ate bratwurst, and Adam resisted making it sexual. He could tell it was the worst thing he could do with Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They shared a funnel cake.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam popped a piece into Shane’s mouth, wondering where he’d gotten such a silly 1950s idea, and was rewarded with the sweetest smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There hadn’t been any kissing, though, although several times Adam thought it was going to happen. There hadn’t been much touching either, although Adam had certainly wanted to touch him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing had really happened until they were crowded near the stage, the day almost over, watching the First Ladies of Disco. Three famous divas from before either of them were born, but they were kicking ass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne was gone by then. She hadn’t wanted to deal with the crowds, and she "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hated")]), _vm._v(" disco, was much more a Mary Lambert or Tegan and Sara fan.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was right when the singer was singing about getting absolutely soaking wet(!) that Shane linked his fingers into Adam’s right hand and then a few minutes later kissed him—kissed him hard—that Adam realized he might have a chance. And he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("wanted")]), _vm._v(" a chance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Crazy. It was crazy. He didn’t spend all day with a guy seeing what was to come! What might come. It was easy to get laid if you really wanted to. Even for a guy like him. Not gorgeous. Not a ten.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God, you’re gorgeous,” Shane had said then, crying into his ear to be heard above the blasting speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No I’m not")]), _vm._v(", he thought. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("But you are.")]), _vm._v(" He shook his head. “You are,” he shouted back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They kissed again, and quite suddenly there was that strange, high, piercing shrill noise in his head—stabbing him like an ice-cold pick right to his temple—and he’d pulled away and saw that Shane was covering his ears like he heard it too—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(It’s not in your ears; it’s deeper, much deeper!)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—and shaking his head, and then just as suddenly, the noise was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Feedback from the speakers, that’s what it is")]), _vm._v(", he told himself.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then, as a thousand times before, the music was over, and moments later those in charge were hustling people out the gates—herding them like cattle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They found their cars (they were holding hands, actually holding hands), and Adam asked Shane if he wanted to go to The Male Box for a couple drinks, but Shane didn’t want that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve had enough of crowds,” he said. “I’m not used to so many people. I should have gone home hours ago. I live three "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hours")]), _vm._v(" from here!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Want to go back to my apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Long pause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then a single nod.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They parked next to each other as soon as they could and then waited together in Adam’s car for the parking lot to mostly clear. That was where Shane asked if he could touch his face—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve been wanting to all day.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked so cute and sweet when he said it, all Adam could do was nod his head yes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then Shane did, and Adam shivered (both of them did, actually) and said, “So soft. I didn’t know what it would feel like. But it’s so soft….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam couldn’t help but kiss him then, and Shane kissed back, and Adam got so hard he thought he might ejaculate in his pants like a teenager.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—and afterward Shane followed him back to the Oscar Wilde.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They went into the building, took the elevator up—Shane’s nervousness was palpable—and entered Adam’s apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nice,” Shane had said, looking around.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s apartment wasn’t. Not real nice at least. And it was messy. There were empty takeout containers on the coffee table and in the kitchen. Magazines and fag rags littered about. He was embarrassed. Then Shane asked him if he had anything to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’d rather kiss you again,” Shane said. “But I’m so fucking nervous I could puke.” He rolled his eyes. “I guess that wasn’t very sexy, was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam told him not to worry about it and cleared off the couch fast. “Sit,” he said and went and got the Crown out of the freezer. He poured two fingers’ worth into a pair of glasses and brought them back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What is it?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Whisky,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane grimaced.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“This isn’t Old Crow,” Adam said. “Try it. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Sip")]), _vm._v(" it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So Shane had. He’d grimaced again—but not nearly as much.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked up at him. “Sit.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They drank.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then they kissed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was sweet and hot and wild and adorable all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They kicked off their shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They took each other’s new T-shirts off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane climbed into Adam’s lap.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Adam surprised them both by standing and clasping Shane’s (hot little) ass and carrying him to the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("…then they made love. Or something like it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s usual technique would have been to tear Shane’s jeans off and start a rock-and-roll party. But even in his darkened bedroom, he could see the fear and the hope and the desperation in Shane’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What came next was something between wild sex and sweet sex.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was utterly amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The only downside was when Adam started making love to his ass—he’d wanted that rounded perfection all day—Shane panicked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t fuck!” Shane had cried.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay,” Adam assured him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("He’s a virgin?")]), _vm._v(" Of course the possibility had been there all day. “You’re a virgin?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had looked at him like a wounded puppy and whispered, “Down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Down where Adam was, between his legs, kissing his perfect rounded cheeks, had been running his tongue down the deep cleft between them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But I’ve been with men. A "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("few")]), _vm._v(" men.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had looked at Adam as if he were asking for forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So then Adam had assured him that fucking him wasn’t what he wanted to do and showed Shane the wonders of what a tongue could do to a tiny, tight hole and then kissed him everywhere. Shane had cried out in delight, which only spurred Adam on. Virgin he might not be, but instinctively Adam knew the sex Shane had experienced with men in Buckman, Missouri, wasn’t anything to write "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fifty Shades of Grey")]), _vm._v(" about.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was right.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And as inexperienced as Shane had been, Adam still gave him his phone number. His real phone number.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And they’d spent every weekend together since.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("11")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“WHERE DID")]), _vm._v(" you get all this stuff?” Adam asked, pointing to the books on his coffee table. He’d almost said “this shit.” He was sitting next to Shane, and their thighs were touching. Normally that might have been erotic. Now he wasn’t sure what he was feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve collected it for a long time. Got a lot of it online. You don’t find many books like this in Buckman. Not at our little bookstore, that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was hardly much of a bookstore. At least as far as selection. They also served breakfast. It was kind of charming, Adam had come to admit, but the Library of Congress it wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane turned his head and caught Adam’s eyes with his own. “Why do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t have a clue,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The look on Shane’s face was obvious. He didn’t believe Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But he should.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t know what Shane was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Liar.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was an infinite pause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then: “The time that you lost on the road last weekend….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What about it?” Adam said, and something… twisted inside him and he knew he was avoiding… something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have you ever had that happen before? Have you lost time?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” He almost got up, but the sincerity in Shane’s voice kept him there.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He felt that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("twist")]), _vm._v(" again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Especially late at night? Driving out on empty roads where there was nobody else around?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam blinked at him. What was he asking?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then that niggling little thought began to tickle at his memories…. He shook his head. That tickling made his stomach clench even worse. Made him feel cold. Made him feel….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” he said (lied).")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Never?” Shane’s eyes were so wide. Desperate?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A sudden image of camping out when he was in fourth grade. Pup tents. He’d been in the Webelos, a group that was sort of the “junior high” between the Cub Scouts and Boy Scouts. He and his buddy Skip had snuck off to go skinny-dipping. The moon had been just rising over the lake. And then quite suddenly it was high overhead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He hadn’t thought of that in years.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked away from Shane. He didn’t want him to see.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("See what?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane leaned back and put his arms behind him. It made his baggy T-shirt ride up and revealed his well-filled underwear. Maybe they could forget about this stuff. Somehow Adam knew, just "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("knew")]), _vm._v(", that he didn’t want to talk about these books. This time-loss stuff.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For me? The first time I was in… fourth grade, I think? I was hanging out at this old abandoned house.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Fourth grade.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Webelos.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked away again. He wanted to put his hands over his ears. And the thing was, he didn’t know why.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because five or ten minutes ago, everything was normal and he was definitely coming to the conclusion that he was falling in love. He’d woken up and Shane wasn’t there, and he was thinking about how much he missed him even though he knew he couldn’t be far.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he’d thought to himself, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I think I’m in love")]), _vm._v(". And he’d smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now, though, he was sitting next to Shane, and these weird books were on the coffee table, and he was panicking. And he didn’t even know why. Why should that be anything to panic over?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me and Mom,” Shane went on. “We lived out in the middle of nowhere so I didn’t have anyone to play with, you know? And Mom got me this little motorcycle.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You had a motorcycle in fourth grade?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave a half laugh. “It was more like a bicycle with a motor on it. I wasn’t going anywhere fast. But I sure pretended. Usually that I was the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ghost Rider")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That dumb movie with Nicholas Cage?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane shook his head. “No. The comic book. The comic book was really cool. Great art. Anyway, I would ride down the road about a quarter mile or so, and there were these three old houses at three of four corners. One had fallen over, and one my mom had flat-out forbidden me to go to ’cause it looked like it could fall over any second, and the last one… well, it was kinda cool. At least to a fourth grader. I’d go in there and play. Whoever had owned it even left some furniture in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And it was okay with your mother for you to play in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("there")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane smiled at him in that way that usually got his heart beating faster. “Well… she hadn’t actually "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("forbidden")]), _vm._v(" it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane laughed, and Adam tried to join him. It didn’t sound real at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Anyway, I was in there playing one day, and I felt someone tap my shoulder.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A shiver passed through Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I turned around, and there was nobody there. But then something caught the corner of my eye, and I looked, and there was this man.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A man?” Adam asked, and for some reason, his stomach got heavy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded. “He was standing down the hall in the kitchen. He was wearing a long black coat, and he had on this black hat. He had his arms up in front of him—” Shane raised his hands and then hung them over each other, limp, demonstrating. “—like this. I could only barely see his face. He was standing back in the shadows, and there was this shaft of sunlight between us, and I remember seeing the dust moving around in that light so clearly. I thought he said something then, thought I could almost see his face. These eyes, big and up to either side of his face instead of where they were supposed to be, and the next thing I knew, I was sitting on the floor and the shaft of sunlight was gone. I….” Shane gulped hard. “I jumped up and looked around, and the sun was almost setting. It couldn’t have been later than four in the afternoon at the most. And then suddenly the sun was setting. Scared the shit out of me. I ran for my bike and raced home and dashed into the house and told my mom all about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What did she say?” Adam asked, knowing the answer. She would have thought he was being silly. Would have told him he fell asleep. Of course she would….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She said, ‘Oh! You met the man in black.’”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("12")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM DIDN’T")]), _vm._v(" understand what Shane was getting at, although it was clear that Shane thought he should have.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She knew who this guy was?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane’s eyebrows went up. His expression was “Are you shitting me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam wasn’t shitting him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane sighed and leaned back again, hands behind his head. The T-shirt hiked back up, and the underwear once more revealed something that Adam was far more interested in right now than pursing this conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re being deliberately slow here, Adam.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let’s go to bed,” he said hurriedly and then laid his hand on Shane’s sexy, just-hairy-enough thigh and let it slide slowly upward.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane dropped his hand onto Adam’s and stopped it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Later. If you still want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam pulled his hand away. “Later what?” he cried.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A long sigh was Shane’s response. “Let me back up.” He sat up. “I was late for dinner. Mom didn’t even ask why. She just had me sit down and got me a glass of milk. Then she started serving up our food. I can’t remember what we had except for macaroni and cheese. That kind from Kraft. She made it all the time. It was cheap, and we needed cheap. We ate lots of ramen noodles and tuna too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then she sat down and told me her story. Told me about how one day she was cleaning house while I was at school. She said she had just sprayed the inside of the stove with cleaner, and she looked up and there was this man standing there. Startled her. For some reason this little house had a really big kitchen—it was bigger than either of our bedrooms—and she guessed that was why she hadn’t seen him right away. He was standing in a corner, and he was wearing this long black coat—like a trench coat—and his hands were crossed up in front of him. Kind of like a praying mantis.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The insect men?")]), _vm._v(" Adam wondered. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Geez")]), _vm._v(". And then wondered what had brought such a thought. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Insect men?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s what she said anyway, and that made me think it was just what the man I met looked like. She said she was totally shocked—but not shocked at the same time. That once she saw him, he seemed familiar. She couldn’t see his face. Not clearly, and that didn’t make any sense because it was right around lunchtime and there was plenty of light coming in through the kitchen window. Somehow his hat, the brim, was keeping his face in shadow… but not.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane rubbed at his upper arms, and with that simple gesture, Adam’s own arms broke out into gooseflesh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She said she thought the more she looked, she could almost see his eyes, but they weren’t where they were supposed to be. That they were more up here.” Shane cupped his hands and then placed them above and to the sides of his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Like a praying mantis")]), _vm._v(", Adam thought. And once more shivered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” Shane said. “Just like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Did I say that out loud?")]), _vm._v(" He hadn’t thought so.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mom told me she wasn’t scared. That there was a part of her telling her that she should be, or "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("maybe")]), _vm._v(" she should be, at least, but that she just wasn’t. That there was this man suddenly inside the house, and she should have screamed and run, but she didn’t. She just said, ‘Hello.’”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Hello?")]), _vm._v(" “Hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded again, but this time Adam knew he’d spoken aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hello,” Shane repeated. He ran a hand through his short hair. It was messy from sleep, and Shane’s finger combing had done nothing to help matters. Not that hair as short as Shane’s could get that messy anyway. “Then the man told her that it was time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Time?” Adam asked, and realized he really had become some kind of human echo.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is fucking weird.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup.” Shane smiled but it was a strange one. Not nice at all. Not Shane’s sexy smile or even one of his big laughing takes-over-his-whole-face smiles. It was kind of creepy. “She told him that it would have to wait until another day because she had just sprayed the stove and it was important that she wipe it down in thirty minutes, but then he reached out, and she saw that his fingers were thick and very long, and the next thing she knew she was sitting at the table and I was coming in the front door. She realized that she’d lost the entire afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had to fight the urge to jump up and leave the room. What Shane had just said was bonkers and creepy. It was the other shoe. It had dropped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mom said this happened once or twice more, but then it stopped. So when I told her what happened to me, she knew just who it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who was it?” Adam exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane rolled his eyes. “Adam!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("what")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A man in black!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God. Oh fucking God. A man in black? Really? “Will Smith or Tommy Lee Jones?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The expression he got in return was a hurt one. And that made Adam feel bad. But not bad enough. This was wackadoodle. “And she wasn’t the least bit freaked the fuck out?” he asked, trying to back things up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane shook his head. “No. She said he never harmed her. Not that she knew of. In fact she said she found out that leaving oven cleaner in the oven for several hours made it easier to clean.” Then he looked at Adam so calmly, so matter-of-factly, that Adam burst into laughter and suddenly all was well with the world.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane was pulling his leg.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Joshing with him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kidding around. Yanking his chain. Clowning around. Busting his chops. Messing with him. Kidding.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Shane ruined it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s happened to me a lot of times since then,” Shane said. “Me losing time. I never saw the man in black again—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Wait! Wait just a ")]), _vm._v("goddamned"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" minute. Man in black?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—but there are times when I just lose time. It’s almost always when I’m driving. I don’t think it has happened while I was at home. I don’t live in Manhattan, or even Kansas City, but if something came down to get me when I was at the house, then people would see….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("See? People would see?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("See what?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But Adam knew just what Shane was saying. It was in the books laid out before them. UFOs. He was talking about frigging U, F, fucking Os!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is crazy.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("How is this happening?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked at Shane. A guy whose flaws had been cigarettes and baseball. And now what?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("He believes in UFOs.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("UFOs that took him away!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Did Shane actually believe that he’d been abducted by aliens?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not that people don’t see them all the time. That part confuses me. Why all the secrecy when sometimes they don’t seem to be concerned in the least.” He picked up the book called "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs Caught on Film")]), _vm._v(" and began to leaf through it. Showed Adam a page. Then another. And another.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All of which were pictures of flying saucers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So many of these were taken in broad daylight. I mean, I know a lot of them were out in the middle of nowhere—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Like in Buckman, Missouri, population somewhere around four thousand people and far from any kind of real civilization?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—but some of these are over huge cities or towns. Look at this one.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was gooseflesh again, and Adam didn’t want to look. But the page had been shoved pretty much under his nose, and when he focused (involuntarily) on the photograph, he saw a dark disk with several blue lights beneath. It was hovering or flying over a tree and some power lines. The notation said 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you really believe in this stuff, Shane?” he asked. It was more of a whimper. Things had been going good. He really, really liked—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(loved)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—this guy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But the other shoe had dropped. The shoe he was somehow waiting for because nothing should be as perfect as this had been. Nope. Not perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane was wackadoodle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("13")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM BORE")]), _vm._v(" Daphne’s hug today. He wasn’t in the mood to be touched. Not even by Daph.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They sat down on either side of the long slim table. “Surprise, surprise,” Daphne said. “Saturday morning coffee again. Shane didn’t come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Of course that would be the question. He shook his head. “All they have today is Colombian. Three kinds.” He sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One of her eyebrows started to rise… then fell back into place. “Well, good for me anyway. And it’s good to see you, brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He tried to smile and told her that it was good to see her too. It was, wasn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neither said anything for a stupidly long moment, and then she shrugged and got up to grab one of the small clipboards that served as a menu at The Shepherd’s Bean. A half sheet of brown (unbleached) paper stated today’s offerings, which could be different (and often were) from just the day before. “This first one looks good,” she replied matter-of-factly. “The Finca Aracatace?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It is your turn to buy,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was it? He couldn’t really remember.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure,” he replied and went to the counter. The girl with the big glasses wasn’t there. The real reason Daphne told him it was his turn to order, perhaps? There was a cute boy barista today, one he hadn’t seen before, with lots of tattoos and wearing a wool cap. A tumble of dark curls spilled from beneath its edge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Cute.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Not as cute as Shane.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Stop it!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He ordered the coffees and went ahead and got a plain doughnut for Daphne and a chocolate one for himself, then rejoined his sister at the table.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So where is Shane?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shrugged, trying for a not-a-care-in-the-world look. “I assume he’s at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Which is where again?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Buckman.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She gave a nod and took a bite of her doughnut. He tasted his own. Delicious as always.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So why aren’t you with him?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shrugged again. “I wanted a weekend off,” he said, not meeting her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another nod. Another bite. Another pause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then, “From the way you were talking, I kinda thought a weekend off was the last thing you’d want. I was hoping anyway. I liked the idea of you having someone in your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He was a distraction,” Adam fired back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her face was completely noncommittal. So Daphne. So police detective.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And I was feeling guilty about skipping our Saturday mornings. I thought you’d want to see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I always want to see you, Adam. But we can see each other anytime. You can only see Shane on the weekends.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I wanted a weekend off!” He immediately regretted the force of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The cute barista brought their coffees. He tried to lock eyes with Adam, who refused to allow it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Once Coffee Boy was gone, Daphne asked, “What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nothing!” Too strong again. He sighed. Took a drink of his coffee. Not bad. The special fermentation process the menu described must have helped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry,” Daphne said quietly. “I don’t mean to pry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You always pry,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well someone has to!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked up, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne bit her lower lip. Like Shane did. Adam shook the image from his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry,” she said again. “But it’s like I said. I liked seeing you with someone. I liked the idea of you not being alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t need to be with anyone,” he said and took another drink of his coffee. Not bad. It wasn’t bad at all. At least it was a distraction.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She said, “Of course,” and bit into her plain, boring doughnut. “But being with someone is nice. I know I’d like someone to come home to.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You?” He was taken aback both by the comment and the look in her deep dark brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me.” He could barely hear her she said it so quietly. Then, louder: “I was getting kind of warm thinking about the two of you cuddled on the couch watching TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For some reason this surprised him as well. “You were?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He thought about it a second. He and Shane on the couch watching TV. Cuddling. Then he thought of the UFO books, and he blew a raspberry.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That bad?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That bad,” he said with a sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The cigarettes get to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He paused. No. Amazingly they hadn’t. Especially with all the care Shane had taken to always step away to smoke and to constantly use that breath spritz.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam could almost smell it. Felt a tiny pang of missing it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But it wasn’t the cigarettes. Or the baseball games. Not any of that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s wackadoodle,” he said by way of an explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“To fall in love with you, he’d have to be,” Daphne responded with a little smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("In love?")]), _vm._v(" “In love?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She gave a single nod. “I think he fell for you before he sat down on that blanket.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam scoffed at the idea. “Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I mean it. That’s why I was so happy to see he was the reason you’d been skipping our Saturday mornings. Not just because you were seeing someone, but I’d been thinking he was another boy whose heart you were going to break.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked at her in astonishment. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ve left a string of them behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me?” Even more astonished.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course.” She drank her coffee. “You’ve always had trouble with relationships, with trusting anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You psychoanalyzing me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You meet them and see them once or thrice and then cast them aside. More than one has seen me out and asked me what they’d done wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s mouth fell open. “Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I always wondered why you didn’t keep one. I’d love it if someone was interested in me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What the hell are you talking about?” Casting aside? String of broken hearts? WTF?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I mean, I can’t remember you seeing someone for as long as you were seeing Shane….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Long? It was only, what? Six weeks or so?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Does this mean it’s over?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Over?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane’s image shimmered into his mind’s eye. So cute. Sweet. His heart felt a twinge. God. This is why he didn’t—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(fall in love)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—let himself feel for anybody. He could get hurt. They got power. He didn’t want anyone to have power over him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Over? Was it over?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know,” he said and looked through the big windows onto Main Street. God. His heart was still feeling that dull little ache. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I miss him. God, I miss him.")]), _vm._v(" “He’s wackadoodle, Daphne! He believes in UFOs!” He froze. Looked around him. Coffee Boy was giving him an odd look. Adam looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“UFOs?” One of her perfect eyebrows was high enough to near disappear under her dark bangs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“UFOs,” he repeated. But quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He thinks he’s been abducted!” He cringed and glanced at the barista, but he was busy with a customer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He expected Daphne to look surprised. Instead, that eyebrow had dropped down to its customary place.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well?” he asked. “Is that crazy or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something funny happened then. Something in Daphne’s eyes. They seemed to grow darker. Strange. He’d read about dark clouds coming into a person’s eyes, but like never having seen someone laugh all the way to the bank, he’d never really "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("seen")]), _vm._v(" those storm clouds in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Until now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Daphne…? Sis?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She turned back to him. Shrugged. “After a while you see all kinds of weird things, Adam. What’s that thing that Shakespeare said? Something about there being stranger things under heaven and earth that you can dream of?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shakespeare? Really? Daphne quoting—or trying to quote—Shakespeare? "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Really?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her eyes grew even darker. He actually "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("saw")]), _vm._v(" it happen. Then after an infinite seeming pause, her eyes flicked back to normal and she said, “I’ve seen some "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("weird")]), _vm._v(" shit the last year or two, Adam. Some "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("really")]), _vm._v(" weird shit. So UFOs? Who am I to say?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("This only agitated him all the more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, what about this? He thinks I’ve been abducted too! How’s that for fucking freaky?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("14")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“LET’S GO")]), _vm._v(" to bed,” Adam had said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then Shane had said, “Later. If you still want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He already didn’t want to anymore. Anything to end this conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think maybe you’ve been abducted too, baby,” Shane had said quietly. “I think it happened to you on the way from my place last week. And maybe because you were with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had flinched at the comment. Flinched back as if he been burned or shocked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But why?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The whole idea was ridiculous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Abducted?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But the expression on Shane’s face told him that Shane wasn’t kidding. Wasn’t pulling his leg. He was serious. Serious as a heart attack. “How else do you explain your missing time? You were missing a lot of time, baby. How do you explain that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam willed himself to relax. He took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Come on, Shane. You don’t really believe that, do you? That’s crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is it?” Shane asked. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam laughed. It wasn’t very convincing. Not even to himself. “Come on, Shane! Aliens? You don’t really think that, do you? I mean that’s all fine and dandy for a movie like "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Close Encounters of the Third Kind")]), _vm._v(". Fun. But you don’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("really")]), _vm._v(" believe that shit, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But Adam saw it. Shane did believe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Wackadoodle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The other shoe had not only dropped, it had fallen through the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is what I get. Never again.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sighed. “Shane, it’s like I said. Simple as can be. I got hypnotized by the headlights of the oncoming cars. I was tired. It was a long drive. Anything could have happened. I could have driven over to the shoulder and slept.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave him an incredulous look.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s certainly more believable than aliens! And if it was, why can’t I remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“People almost never remember,” Shane said. He picked up the book that had the word “captured” on the cover. “This book.” He pointed at the photograph of a white woman and a black man. “It’s all about the famous case of Betty and Barney Hill. No one has ever been able to disprove it. They couldn’t remember what happened to them either. So they were hypnotized to bring back their memories. And that proved they were abducted by aliens.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam grunted. “That doesn’t prove shit. What’s been proven is that hypnosis can cause false memories.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But there are hundreds of cases, Adam. Charles Hickson and Calvin Parker in Pascagoula in 1973. The Walton Experience—they made that into a movie. Ever see "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fire in the Sky")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam jerked. Yes, he had seen that movie. The ending had given him nightmares for weeks. Of course he’d been a little kid when he’d seen it on TV. What kid wouldn’t have a nightmare after seeing all that slime and gore and scary shit?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Goose bumps once again rushed up and down Adam’s arms.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Whitley Strieber wrote about it in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That")]), _vm._v(" one. Another case of wackadoodle!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s famous.” Shane placed a pointer finger on that book on the table. “No one has ever been able to disprove his story either.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was all Adam could do not to jump up and leave the room. That feeling was coming back. Chilling. He felt nauseated. “No,” he moaned. “I do not believe it. They were a bunch of crazies. Or attention seekers looking for their fifteen minutes of fame.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam! Who would want that kind of fame? Who would want the world to think they were crazy or liars? People lose everything when stuff like that gets out. Their jobs. Friends. Family. Lovers. Who would want that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Adam was standing up. He really did feel like he might throw up. “Enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You can’t believe we’re all there is, can you? The only life in the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("whole")]), _vm._v(" universe?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I never really thought about it,” he shot back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All those billions of stars? You don’t think we’re all there is, do you? You don’t think we’re the only intelligent life?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam clenched his fists. Once more forced himself to calm down. Why was he acting like this? Feeling like this? It was silly. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Calm down.")]), _vm._v(" He swallowed hard. “I suppose not. But flying saucers? Aliens taking people up in their spaceships and giving them anal probes? No. I don’t believe that. Not for a freaking second.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Since the 1930s over eleven million people have seen a UFO, or know someone who has. One study says that as much as five to six percent of the general population may have been abducted—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Right then that high, piercing, ear-slashing, brain-stabbing noise came back. It was the first time in weeks, and Adam winced and cried out and covered his ears. But it wasn’t coming from his ears, was it? Even though it sounded so much like feedback from a huge set of concert speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was coming from "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("inside")]), _vm._v(" his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And when Shane jerked in his seat, Adam knew that he had heard it too. But how was that possible?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then as quickly as it had come, it was gone, leaving only a painful echo in its wake.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They looked at each other for a long time. Then Adam said, “And just what was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Implants,” Shane whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("15")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THEY DIDN’T")]), _vm._v(" go back to bed that day. They didn’t have sex. They didn’t make love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They went out for lunch at Hamburger Mary’s on Broadway, but Adam could hardly eat. He just wasn’t hungry. Still felt nauseated and didn’t know why.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They went and saw a movie, but Adam barely paid attention to it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His heart wasn’t in it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Wasn’t in anything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Shane left before he normally did despite the fact his shift at work had changed and he didn’t need to get to bed early.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because implants.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Implants?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane thought they had implants!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ruined.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was all ruined.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam was relieved when Shane left.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("16")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("AND THAT")]), _vm._v(" night he wasn’t sure he ever wanted to see Shane again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("17")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“THERE ARE")]), _vm._v(" stranger things,” Daphne repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Than me being abducted? Than little green men—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They’re supposed to be gray,” Daphne said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—probing me and putting implants in my head?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His sister lifted and dropped her shoulders in one quick move.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Daphne,” he exclaimed. “It’s crazy!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And like I’ve said, I’ve seen some crazy shit. Experienced some crazy shit. Makes a believer out of you. Or at least made it so I can’t be so quick "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not")]), _vm._v(" to believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, Daphne,” he said, disappointed. He’d called her—truth be told—knowing she’d add normalcy to what had happened. He hadn’t expected her to make things worse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can I ask you something, brother? Isn’t it possible? Why isn’t it possible? Why couldn’t there be life on other planets? Why couldn’t they come here? Why wouldn’t they want to study us? Isn’t it possible?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Daphne. Oh, Daphne.")]), _vm._v(" “What kind of stuff have you seen?” he asked aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She looked away. After a long moment Adam realized she wasn’t going to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Daphne?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She turned back. “I don’t care what he believes, Adam. I want you to think about if it matters. So he believes in little gray men. So he thinks he was abducted by them. So what if he thinks "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("you")]), _vm._v(" were? He’s special. He cares about you. You care about him. You like him. I think you’re falling in love with him. Isn’t it possible that what’s really going on is that you’re using this as an excuse to run? That you’re afraid of getting involved?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head adamantly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think that’s what’s going on. And what I think is that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("you ")]), _vm._v("need to ask yourself if you really want him to slip through your fingers. Everybody has their flaws. No one is perfect. But I think he just might be perfect for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam opened his mouth to reply… and then let it slowly shut.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Did he want lose Shane?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("After that he and Daphne didn’t talk much.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("18")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM DIDN’T")]), _vm._v(" sleep well that night. Of course, he hadn’t in days, but tonight was different. He couldn’t stop thinking about what his sister had said. Couldn’t stop thinking about a lot of the things she had said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Things she had seen that made her believe that weird shit was possible. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("His")]), _vm._v(" sister. The queen of practicality.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That she believed Shane might be perfect for him and he’d be stupid to let him go.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because God, he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("had")]), _vm._v(" been thinking that Shane might just be perfect for him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Couldn’t he allow Shane to believe in his UFO stuff? Couldn’t he just forget about it? Ignore it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was it any worse than the cigarettes? Than baseball?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Yet it was more than that. Much more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The whole thing made him powerfully uncomfortable. Sometimes sick.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And sometimes scared.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which made no sense at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But more even than that was the fact that he couldn’t stop thinking about Shane. How much he missed him. God, how much he longed for him. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Longed")]), _vm._v(" to be with him. To touch him. To sit with him. To make love with him—and yes, dammit, that was what it was. Making love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("More than ever, though, just to be with him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They didn’t have to do anything sexual.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Just to hold his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And to see those eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And that cute (wonderful) half smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was more than missing Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was an ache.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Being away from his man hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("My man….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God. My man….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("19")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("SO THE")]), _vm._v(" next day, unable to even concentrate at work—and working in billing for cancer doctors he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("needed")]), _vm._v(" to be able to concentrate—he made a decision.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why not do a little research himself?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("On the way home, he stopped at Half Price Books and asked if they had a section on UFOs. Not only did they, but they also had a surprising number of books.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He found almost all the books that had been lying on his coffee table.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He bought "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v(" by Whitley Strieber. And several more as well—after all, half price. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Alien Abduction Files")]), _vm._v(", by Kathleen Marden. She was the niece of that famous couple who had been abducted. In fact, they had "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Captured! The Betty and Barney Hill UFO Experience")]), _vm._v(" as well, written by the same lady. They even had a beautifully bound collector’s edition of the original book about Betty and Barney Hill, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Interrupted Journey")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That was the paperback Shane had.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He could see it in his mind’s eye, only the word “interrupted” visible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He saw the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs Caught on Film")]), _vm._v(" book as well, but after leafing through it, he found it made his stomach ache. It made him uncomfortable in a way even the Strieber book’s cover couldn’t—with its portrait of the alien face and its huge dark eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The pictures were… not right.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It didn’t look like any of them. Not really.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And even thinking those thoughts almost sent him running for the bathroom. He pushed them from his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He grabbed "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The UFO Files")]), _vm._v(" by David Clarke and then as a lark added "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Never Again: Techniques to Avoid Being Abducted by Extraterrestrials")]), _vm._v(" by Mary Minden, because it had to be a joke, right? He looked at the index. It wasn’t real. Come on. Mental Defenses? Spiritual Defenses, Pray to God? Protective Foils and Crystals? (like the foil hats that Joaquin Phoenix and the kids wore in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Signs")]), _vm._v("?) Repellants? (Raid, perhaps? Or maybe Off mosquito spray?)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Had to be a joke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d have to share it with Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane. God, Shane.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam spent hours over the next week reading. Studying. Making notes on a yellow pad he’d gotten from the storeroom at work. He learned about famous so-called abductions. He learned that there was more than one kind of alien, not just the little gray men with huge heads and big slanted black eyes—the “Greys.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(And why were they called “Greys” when the color was spelled “gray” and apparently there were two accepted spellings of the color?)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There were also these tall Norse-god-like beings with long blond hair and huge, beautiful pale blue eyes who spread a message that they wanted us to all live happily together and stop waging war—which all sounded very 1960s/hippy/too-much-LSD to him. “Venusians.” And how silly was that? Blond, blue-eyed aliens from a planet overwhelmed with deadly gases and sulfuric acid rain? Really?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then there were the insectoids, the reptoids (or reptiloids depending on the author), chameleons (reptilian aliens genetically bred to appear human), chupacabras ("), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("really")]), _vm._v("? Chupacabras were "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("aliens")]), _vm._v("?), eva-borgs (this sent Adam into great peals of laughter—apparently they were cybernetic things controlled by aliens, and all Adam could think of was “resistance is futile!”), dwarves, dragonworms (too silly to even read about), Tau Cetians (who looked like tan-skinned humans except for slight differences like pointed ears—hey, maybe the aliens needed to sue Gene Roddenberry—it sounded like he had infringed on their copyrights with the ears and the Borg), the Anakims (the giants referred to in the Bible? “There were giants in the earth in those days”? It was to laugh), amphibians (why not? There were reptiles after all), and oh, it went on and on, but those were the most “common.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He read and read and read—and he wasn’t even sure why, because God, aliens?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But not after it got dark. He couldn’t read after dark. Couldn’t crack a cover. That’s when he got sick to his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He made covers out of brown paper shopping bags for the books he took to work. No questions. He didn’t want any questions. There would be. Someone would tease him. That jerk Bobby Brubaker, the office manager, for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had found a few used DVDs as well, including the one that had scared him as a kid—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fire in the Sky")]), _vm._v(". He grabbed "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Fourth Kind")]), _vm._v(" and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Signs")]), _vm._v(" and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Close Encounters of the Third Kind")]), _vm._v(" while he was at it. The prices were right. They didn’t have "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v(" or the TV movie based on "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Interrupted Journey")]), _vm._v(". He thought he might order it on Amazon. After all, James Earl Jones and Estelle Parsons were in it. Had to be good, right? Or at least decent?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fire in the Sky")]), _vm._v(" didn’t bother him nearly as much as he expected it to, but then he watched it at noon when the sun was shining brightly through his living room windows.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The scene was wrong. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It wasn’t like that. No slime. No gore. No dead bodies. Wrong. All wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he considered those strange thoughts, he decided not to. Once more it was time to banish them. But Bradley Gregg, the guy who played Bobby Cogdill, was hot. Damned cute. He reminded Adam of Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He didn’t like the part in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Signs")]), _vm._v(" where the alien was in the corn. Or on the roof.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. Not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when he knew that only "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Close Encounters of the Third Kind")]), _vm._v(" was safe enough to watch after dark.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He read and made notes. He couldn’t stop. Even though he had nightmares.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nightmares of faces and blue light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The worst, though, was the guilt. Guilt because he hadn’t called Shane. He wanted to. But he couldn’t. He just couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("20")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE BOOK")]), _vm._v(" by Minden really was silly. Hilarious when he finally realized it was for real, at least as far as its author was concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Never Again: Techniques to Avoid Being Abducted by Extraterrestrials")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The author claimed to have been studying unidentified flying objects since the fifties when she saw a UFO as a ten-year-old while camping.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That caused a chill.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Camping?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Camping. Skinny-dipping. Rising moon. And then suddenly the moon high in the sky….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her bio went on to say that she was with an organization called the CSSU (Committee for Special Studies on UFOs) all through the late sixties and the early seventies, until the FBI and CIA infiltrated it and used immoral techniques to tear the organization apart (which didn’t sound the least bit paranoid, right?). It was while she was a member of this group that she met the renowned Ufologist Stephen Neary. Together they studied many cases of UFO sightings and abductions and even consulted on several movies until his death in the eighties from a stroke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In her career she wrote a half a dozen books but it was her book "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Never Again: Techniques to Avoid Being Abducted by Extraterrestrials")]), _vm._v(" that she was the most proud of. Which was pretty sad considering he’d thought it was a joke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Even the reviews on Amazon said so. Or a lot of them did. There were just as many from crazy people who said they’d used her techniques to keep them from being abducted and called her a savior.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was broken into sections with most of them being her so-called protection techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Physical Defenses")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Fight or Flight")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Mental Defenses")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Emotional 1 – Anger")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Emotional 2 – Self Love")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Emotional 3 – Radiant Love")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Emotional 4 – Family Love")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Spiritual Defenses")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Pray to God")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Pray to Other Spirit Guides")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Natural Repellents")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Protective Foils and Crystals")])]), _vm._v(" "), _c('li', {
    staticClass: "P_ListItem"
  }, [_c('p', {
    staticClass: "P_ListParagraph"
  }, [_vm._v("Herbs, Spices, and Oils")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There were also a few chapters on theories of why people were being abducted and what we could learn from how other cultures view aliens. And of course there was the obligatory stuff on ancient astronauts and how mankind couldn’t have built the pyramids without extraterrestrial help.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Poppycock.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam found the Repellants section quite humorous. The author explained that oils derived from amaranth, pennyroyal, St. John’s Wort, and yarrow had been used for centuries for protection against evil spirits and creatures. She postulated that those evil spirits (and beings) could very well have been aliens and that ancient people wouldn’t have recognized them for what they really were. She said she had used various doses to prevent her abductions for years now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But be careful!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pennyroyal had been used to induce abortions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thankfully he didn’t have to worry about that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Patchouli was good too. Especially used in the amounts that lesbians preferred. Knock you out at one hundred feet. He had added that part. The lesbian part. Mary Minden had only mentioned the oil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh! And salt! Apparently if he sprinkled salt around his house, it had been known to work in one or two cases. But then what had Shane said? That even in Buckman, aliens wouldn’t want to take him from his house. And Adam hardly thought he had to worry about being spirited from his fifth-floor apartment. It wasn’t like he was on the highest floor either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh! And crucifixes had been known to help! He’d exploded into laughter over that one. Were they aliens or vampires?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But magnets were what she really guaranteed would work. That had come from the chapter about foil beanies and magic crystals.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One thing he could say about the woman. When he finally figured out the book wasn’t some spoof in the vein of "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mad Magazine")]), _vm._v(", the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Onion")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("and the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Daily Currant")]), _vm._v(" (or Fox News, maybe), he was able to see she was really being sincere. She believed her shit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Too bad it was shit. All shit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And surprise, surprise! OMG! She lived in Terra’s Gate, not forty-five minutes away. What kind of crazy co-inky-dink was that? It was to laugh!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He took a step out on his balcony for some fresh air, a glass of freezer-cold Crown in hand. His back was hurting from the hours and hours of sitting. Between work and home study, he was on the edge of agony. The Crown was barely making a dent in the pain. He needed a massage. He should call his friend Ric. Ric gave great… massages.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But that made him think of Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And that made him feel guilty.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He didn’t like it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He didn’t do guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat down on the brick rail of the balcony, took a swallow rather than a sip of his whisky, and looked down. The evening streets were clear except for a jogger and a lady walking her Westie (he thought her name was Becky and that she lived on the third floor). No prostitutes. How nice. The one time his mother had visited him (she had been in town with some kind of Red Hat Lady’s thing), there had been prostitutes. One huge one had pulled out her breast. Thank God his mom had missed that part.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Adam noticed something else.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was someone standing in the alley. He was wearing a black trench coat. A black fedora. He was holding his hands up in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Like a praying mantis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam let out a muffled shriek, dropped his glass, and stumbled back, arms pin-wheeling for balance to keep him from falling on his ass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was whimpering, jamming his hand in his mouth to keep from screaming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh God. Oh God oh God oh God!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Insectoids.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The word leapt clear and vivid in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He lay on the cement floor of his balcony, shivering.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then he laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oh God, indeed!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was buying this bullshit! He’d seen a man on the street in a black coat and immediately decided he was the insect version of Will Smith. Or the man in black from Shane’s stories!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And if he lived in a tiny town in the middle of Bumfuck, Nowhere, with no reasonable company to talk to, no one sane, no one who didn’t think that country line dancing was a pretty good idea—mightn’t he start believing such bullshit as aliens as well?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He laughed again and sat up. Luckily he remembered to watch for broken glass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He needed a break. And something besides UFO books to read. Porn even. Nifty Archives. Men on the Net.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Anything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Hell, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Twilight")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Looked out into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The man was still there.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was standing under a streetlight, looking directly up at Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His eyes were up and to the side of where his eyes should really go.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam thought his heart just might explode in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He fled into his apartment. He poured salt in front of his balcony door and the ledge of every window. He went to his neighbor Tiff’s door and asked to borrow patchouli. After shouting at him that just because she was a lesbian didn’t mean she owned any, she loaned it to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam used it. He used a lot of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he turned off all the lights in his apartment and went to his bathroom—the only room with a window he couldn’t look out of (and no one could look in). He checked his laptop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To his surprise he found what he was looking for fairly easily.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("21")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM FOUND")]), _vm._v(" her apartment over a bakery called The Sweet Spot on Main Street in downtown Terra’s Gate. There was foil on the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He rang the bell next to the door that went into the shop. He rang it again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hello?” came a woman’s voice from a small speaker to the right of the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is this Mary Minden?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wh-who is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And what did he say? “I….” His throat seized up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who’s there?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Your name, stupid. Tell her your name.")]), _vm._v(" He coughed. Cleared his throat. “My name is Adam Brookhart. I read your book.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was a pause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Which one?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Never Again: Techniques to Avoid Being Abducted by Aliens")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Extraterrestrials")]), _vm._v(",” the woman corrected.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” he said. “Sorry.” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("To-may-to, to-mah-to.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t sign autographs.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t want an autograph,” he said. “I—I….” God! He couldn’t say it. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fuck!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was a static click from the speaker and then nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hello?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Hello")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stabbed the buzzer button again. Then again. Then desperately several more times.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What do you want")]), _vm._v("?” Her voice was all but shrill this time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Please,” he cried. “I need your help. I saw….” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh God. Say it!")]), _vm._v(" “I saw a man in black. He was outside my apartment. He was watching me. I think he might have taken me.” Then to his amazement a sob escaped his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A hundred years later he heard her say, “Come on up,” followed by a long whine from the buzzer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He snatched at the handle before the noise stopped. Pulled. Nothing. Realized he should push. Did it just in time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The door opened to a narrow and darkened stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was halfway up the stairs when he saw her, arms crossed, standing in the shadows, waiting for him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was slim, with gray hair pulled back from her face. She was wearing a black top and a gray crocheted sweater. She stared at him with wide dark eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ms. Minden?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was standing very straight. She nodded. “Yes. And you.” She wiped at her temple with a fist. “You’re Adam Brookhart. And you’ve seen a man in black.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She blinked at him and bobbed her head to the left. “Come in.” Then she turned and went the way of her head bob.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he reached the top of the stairs, he saw she’d gone through a bead curtain. Bead curtain? Who still uses…? Well she was almost certainly a teen in the sixties, wasn’t she? Why not?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The apartment was nice, if a little old-fashioned. But a strange combination of old lady and hippie. Victorian furniture upholstered in burnt orange and lime green. Yuck.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But it was also filled with the smell of baking things. Not overwhelmingly so, but hell, how could it be avoided? The apartment was over a bakery.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when he noticed there was tin foil—or something like it—on the ceiling. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh God. What am I doing here?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh well, in for a penny…")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tea?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("…in for a pound.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Anything but Earl Grey.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One eye twitched. She bobbed her head, which got her big huge wire hoop earrings trembling. “I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hate")]), _vm._v(" Earl Grey,” she said and turned and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That decided him. He would stay.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stood there a moment, not knowing whether he was supposed to follow her or sit down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he heard her voice from the other room. “So how… man… black….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That’s all Adam caught, and he decided she wanted him to follow. He went through another beaded curtain to find her in a small kitchen, filling a teapot with water from the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sorry?” Now it was his turn to cross his arms. His stomach was quite suddenly clenching. “Wh-what did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mary Minden turned around, teapot in one hand, playing with a dark stone hanging from a thin gold chain around her neck. That one eye twitched again, and then she put the kettle on the antique stove. She turned on the gas. “I asked you how you knew he was a man in black. I mean, do you know what a man in black is?” She spoke very fast. “Some people say they’re from the government. Some people say—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Your book says they’re aliens.” His voice froze up on the last word. He’d said it out loud. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Aliens.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m going crazy. Wackadoodle!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do you think?” She turned to face him. Wiped at her temple with a fist. Fondled the stone with her other hand. That was when he saw they were swollen with arthritis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was watching him carefully. Studying him. He felt like a bug. “I don’t know what to think,” he managed. “My boyfriend believes….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Boyfriend!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And quite suddenly he knew he’d better do something quick if he still wanted Shane to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("be")]), _vm._v(" his boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s what I’m doing.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He thinks he’s been abducted.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She didn’t say a word. She just stood there. She crossed her arms. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Studied")]), _vm._v(" him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He thinks he’s been abducted lots of times.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Watching.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He thinks "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’ve")]), _vm._v(" been abducted!” he blurted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Finally she said, “What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shuddered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Flashed on a full moon high in the sky when it should have just been rising over the tree-lined horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("On getting home late from Buckman and the missing time. The inexplicable missing time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("On blue light. Faces.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And a praying-mantis-like man in a black trench coat looking up at him. The man’s eyes were in the wrong place.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He moaned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think maybe it’s true….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The teakettle began to whistle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam let out a gasp and staggered. He almost fell on the floor. Would have if he hadn’t fallen against the threshold, sending strings of beads clattering.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The scream was just the teakettle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But it was too much like those high, piercing, brain-stabbing ice picks he’d experienced with Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane. God, I miss you, Shane….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ms. Minden looked at him with an unreadable expression.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a teakettle,” she said flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sighed and felt completely stupid.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ms. Minden turned back to the stove and turned off the flame. The whistling wound down, and she took the teapot and began to pour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Orange pekoe,” she said. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Not")]), _vm._v(" Earl Grey.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She took the cups and put them on a silver platter and added a sugar bowl and a creamer from an ancient refrigerator. She headed out of the kitchen, and when he offered to take it, she looked at him as if he were insane. For a moment she looked like she might hiss at him. She chose to walk past him instead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He followed her back into her very full living room to find her setting the tray down on a fancy coffee table with gold-painted scrollwork. She sat down on a delicate-looking chair covered in burnt orange "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("and")]), _vm._v(" lime green fabric. Leaned in and poured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Cream? Sugar?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Both, I guess.” He hadn’t had hot tea since he was a boy, and that’s the way his mother always fixed it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She pointed at the love seat. “Sit. You’re making me nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Somehow he didn’t think that was difficult. He sat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That’s when he saw the scar by her left eye. There was a shaft of golden light coming through a small window, and it spotlighted that side of her face. It stood out pink and white, but he thought it might not be too noticeable if not for that light. He hadn’t seen it after all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That eye twitched. She rubbed at the scar with an arthritis-clenched hand. Then she picked up one of the teacups. It had a gold handle and some kind of flowers—roses?—painted on its surface. She sipped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam took his own cup. His hand was shaking. He willed it calm and took a sip. Nope. Not Earl Grey. It was good.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was staring at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You tell me, Mr. Brookhart.” She was caressing the black stone around her neck. Squeezing at it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam put the cup down. His hands were trembling again. For some reason he suddenly felt like crying. What was happening to him? “I want to know if it’s real!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course it’s real,” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam flinched.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ms. Minden started to take another sip of her tea, and he saw that she was trembling. Why?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She peered at him over the rim of her cup and then carefully put it down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes, young man. They’re real. Why else would I have spent my entire life in one way or another studying them? Written the books I have? Lectured? Traveled the world? Investigated? D-don’t you think it is rather insulting to ask "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("me")]), _vm._v(" such a question?” The twitch in her left eye had turned into a tic.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I didn’t mean to offend y—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why would you insult "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("yourself")]), _vm._v("?” She rubbed at the twitching with two fingers in small circular motions. “You know it’s real.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know it’s real! It sounds insane! It sounds crazy!” Wackadoodle. Bonkers. “How can it be? If they were real, we would know by now. It’s like Bigfoot. If he was real, it would have been proven by now. Someone would have found him. If there were a Loch Ness Monster, it would have been found by now. We have the technology. We have satellites that can see a penny on the sidewalk and tell which side is facing—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nonsense,” she said and reached for her tea. “That’s utter twaddle.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Huh?” It was all he could say. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Twaddle?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Our satellites are good, but not that good. At least not the ones our government will admit to having. If—as my husband suspected—we are using alien technology derived from the crash site at Roswell, then perhaps we do have such surveillance capability.” She looked at him unblinking this time, the twitch finally gone. “Keyhole class satellites have an imaging resolution of somewhere between five and six.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Huh?” he repeated and wondered if he was becoming a human echo again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That means they can photograph something five inches or so lying in the ground. They may be able to read the license plate number on your car, and please note I say "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("may")]), _vm._v(", but they can tell whether there is a lawnmower in your backyard. This penny story? It is—what do they say?—an urban legend. A modern myth.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“K-keyhole?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Kennan ‘Keyhole-class’ KH reconnaissance satellites,” she said. “Always check your facts. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I")]), _vm._v(" do.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you think we’re using alien technology?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do not deny the possibility. But I think that they are so advanced that there is little chance that scientists in 1947 could have figured out anything from their technology. Remember that the closest star to ours is 4.24 light-years away. A ship traveling at the speed of light would take over four years to get to us. This isn’t even taking into account Einstein’s theory of relativity. Which isn’t practical. What kind of civilization would it have to be that their astronauts are away for hundreds of years? And Betty Hill said that her abductors came from the Zeta Reticuli system, which is thirty-seven light-years away—220 trillion miles away. That means their ships—at light speed—would take thirty-seven years to get here. And that long to get back. And we’re worried about the time it will take us to get to Mars and back? And again, that’s not even taking into account Einstein’s theories.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Time marches on,” she continued. “So they must have a type of space travel that skips these passages of time. Some people think they travel interdimensionally. The extraterrestrials would have to be incredibly advanced. More than we are from tribes along the Amazon River. A hundred times more. A thousand. Maybe a thousand thousand.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She rubbed at her temple again. God. Would her eye start twitching? But she didn’t seem to notice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let’s say a tribe of people who have lived for generations along a river in South America came into possession of, say, a cell phone. Could they understand it? Could they take it apart and use it to change their way of life? Of course not!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But… that’s not the same thing. They wouldn’t have any technology at all. They wouldn’t even know to try and take it apart. They wouldn’t be able to understand what it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mr. Brookhart—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Call me Adam. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She gave a single nod. “Adam. Then call me Mary. I believe these beings are much more advanced than us, so ahead of us that they don’t even consider us to be much more evolved than monkeys. Think on it. When we capture animals in the wild, then tag them, then release them again—do we explain to them what we are doing to them? Do we say, ‘Sorry, Mr. Bear, we’re doing this to track your behavior.’ When we tag tigers to see about their migratory habits, do we tell them what we’re doing? Or sea creatures. Do we tell them we are just trying to learn about where they travel in the ocean? Of course not! And "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("that")]), _vm._v(" is what is happening with these beings. They don’t explain what they’re doing to us.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Doing to us?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They wouldn’t even be "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("able")]), _vm._v(" to explain. They don’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("think")]), _vm._v(" to explain. They don’t consider us… human, for lack of a better word. They probably consider us only barely sentient.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Barely sentient?")]), _vm._v(" “But…! But they can see we’re more than bears or tigers,” Adam exclaimed. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Crazy.")]), _vm._v(" “They would be able to see we have technology. We have satellites, for God’s sake. We have cars. Cell phones! We’re going to Mars. That isn’t monkeys!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded again. While she grabbed at that goddamned stone around her neck. “But that is how far advanced beyond us they are. Forget about "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Star Trek")]), _vm._v(", where the only difference between us and them is pointed ears or wrinkled noses. Where in a few centuries we’ll have ‘warp drive’ and be able to zing all over the universe in a few hours. I think they very well may think of us as monkeys. Why else would they abduct us? Why else would they feel all right about abducting us?” She was rubbing at that scar again. “Tag us.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tag us?” he asked. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Like implants?")]), _vm._v(" Did she believe that crazy stuff too?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Implants.” Now she was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("scratching")]), _vm._v(" at her scar, and it was making him very nervous. What if it started bleeding? What was she doing?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then he was rubbing at "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("his")]), _vm._v(" temple.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Stop it.")]), _vm._v(" He made himself stop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do they want?” he cried, and realized that as insane as all this was, he was believing it. Or believing it was possible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All because he saw a weird man from his balcony? A guy holding his hands up in front of him?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“To "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("study")]), _vm._v(" us. There is something they want to know. Something that makes us different from them, and they want to know what it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head. “Why? What do they want? Are they going to invade us? Like in the movies?” He was shaking now. Sweating.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, my dear young man,” she said. “They’ve already invaded. They’re here now. And they’re not going anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("22")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("INVADED.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was the word that did it. That sent him into a panic.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t wait to pack. In fact, the only stop he made between Terra’s Gate and Buckman was to get gas. He’d had to pee, but it was only the gas gauge hovering over empty that made him pull off the road.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wasn’t sure how he didn’t get a ticket.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam wasn’t sure when he went from thinking that Mary Minden was a wackadoodle—a very intelligent one, but crazy anyway—to quite suddenly believing her, or believing enough to send him rushing from her apartment to his Subaru.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“INVADED? REALLY?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“In every way there is. Mentally—once they’ve taken someone they can read their minds. Sometimes they can beforehand, but afterward? Afterward there is almost nothing you can do to stop them. They can control you. It’s in all the books. Not just mine. Have you read "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve read it,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And spiritually. Why do you think that some people think the Greys are heavenly beings? Beautiful angels with pale skin and long blond hair and huge blue eyes!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam remembered them. The Venusians. Who spread their hippie messages about how we should all live happily together and stop waging war. And deadly gases and sulfuric acid rain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She laughed. “Norse gods even. They use their mind-reading powers to invade people spiritually and make them think they’re benevolent. Those people are the so-called contactees. People who think the aliens are here to help us. That they want us to stop hurting each other. Stop waging war. Of course they want us to stop waging war. They want us. They need us. I just haven’t figured out why.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had been all Adam could do not to shake his head. Mind control? Really?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And physically. Do you think all those stories about—” She swallowed hard. “—anal probes were all jokes?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Like Cartman from "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("South Park")]), _vm._v("? And the radar dish that came out of his ass? It was all he could do not to burst into laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Something that many abductees have in common is the same with many rape victims. Abductees have trouble with relationships, with trust, with sexuality and their own bodies.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam jerked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What had Shane said?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can’t. I. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Can’t")]), _vm._v(". I just can’t let anything…. I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That’s what he’d said just as Adam was working his cock inside him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had quite suddenly, well, panicked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d even been crying.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had held him close until he’d calmed down. Normally it was the kind of thing that would have sent Adam running—somebody freaking out like that in the middle of sex—with thoughts of “weirdo” in his head. Instead, for some unidentifiable reason, it had made him feel closer to Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And normally that would have sent him running as well. Feeling closer. Letting someone close—in—was one step away from being invaded. But when you let them invade. Like when France let the Germans in during World War II without so much as a shot being fired. Or Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was that what he was doing with Shane? Just letting him in?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why? "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay,” he had said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If the aliens… "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("invaded")]), _vm._v(" their victim’s bodies…. After something like that…. H-how easy can it be for the abductee to allow anyone inside them? It’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("just")]), _vm._v(" like rape.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God. Oh my God.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Could it be? Could it be true? Ridiculous! Shane couldn’t bottom because aliens had anally probed him? Adam wanted to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There are studies,” Ms. Mendin—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mary")]), _vm._v("—told him, clutching her stone so tight her knuckles were white, “that indicate that as much as six to ten percent of the population have been abducted.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s ridiculous")]), _vm._v(",” he’d cried. “How could that be? How is that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("possible")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Young man, for them it would be easy. Who amongst us has not driven a deserted road late at night?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How many of us live in small towns?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane said they wouldn’t come for him in Buckman. That even in a small town someone would notice if a spaceship came hovering over his house.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Spaceship! I just said spaceship! He never said spaceship!")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How many of us have gone camping?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Fourth grade. Camping in pup tents when he was in the Webelos. Skip wanted to go skinny-dipping. He’d been so excited that he’d followed Skip to the lake, and his penis had been as hard as stone. A full moon was rising over the trees, reflecting on the surface of the lake. And then a second later, it was high overhead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Why do I keep thinking about that?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You know why.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You’ve always known why.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Faces.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Faces in his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("WHILE HE")]), _vm._v(" was at the gas station, Adam thought it would take forever to fill the tank. He almost didn’t fill it. Almost just threw in five or six dollars’ worth of gas and hit the road. But then his bursting bladder told him he’d never make it, and so he ran inside and took care of business and let the tank fill on its own—even though Daphne would have had a fit about it. Lectured him on how someone could take the nozzle and fill their tank as well.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“HOW MANY")]), _vm._v(" of us have lost time?” Ms. Minden had asked him. “And convinced themselves that it was because they were so busy that the time just flashed by? Or that they’d fallen asleep and hadn’t realized it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or been hypnotized by the oncoming headlights of assholes with their high beams on, maybe?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Or told themselves—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("convinced")]), _vm._v(" themselves—they must have fallen into some kind of trance while driving all by themselves in the middle of nowhere—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This isn’t real.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—because the alternative is just too horrifying to accept?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It’s crazy.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then why was he racing at a ridiculous speed to Buckman to see Shane?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Because I miss him.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But that wasn’t the only reason.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("There’s lots of reasons!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had to talk to Shane. Tell him the things that Ms. Minden had said. Even if it was crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because sometimes crazy things were true—were real.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But aliens? Aliens invading Earth? “You honestly think they’ve invaded?” he’d asked her. “Like in fucking "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Independence Day")]), _vm._v(" or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She winced, and the tic started again… but it lasted only a second. One, two, three…. It stopped at four. “I don’t like that word.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“‘Something’?” he asked. She didn’t like the word something?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That word you kids called ‘the F-bomb.’ It’s tacky. Unnecessary. Unprofessional. Juven—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kids? Kids? He was thirty-two. “It’s just a word!” he snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nevertheless, I would appreciate it if you wouldn’t use it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fine.")]), _vm._v(" “Fine,” he said. Whatever she wanted. Because she had information he needed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was looking at him that way again. Like he was something in a petri dish.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I won’t use it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No. Not like "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Independence Day")]), _vm._v(". Or "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Invasion of the Body Snatchers")]), _vm._v(". Not even that series from the sixties—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The Invaders")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He didn’t know it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She sighed. “Long before you were born, I suppose,” she said, taking up her tea again. “It starred Roy Thinnes. He was very handsome.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The comment surprised Adam. It seemed so incongruous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("was")]), _vm._v(" a young woman once,” she said. Goodness. Was that a blush?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It was a scary show. Aliens posed as humans. But ours? Our aliens? Posing as humans? No. Nothing like that. But they’re here all right. And the government isn’t doing anything about it. That’s why Stephen thought we were using alien technology.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Stephen Neary. Her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He thought the government was in on it. That they turned their heads and let people be abducted in exchange for advanced technology. In the end he more than half convinced me. They tore the CSSU apart.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The Committee for Secret Studies on UFOs—or something like that. The organization she was in that investigated UFOs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They didn’t like what we were finding out. What we were "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("proving")]), _vm._v(".” She began to shake and rub her temples, both of them this time. “Stephen was growing more and more frantic. Until he had a stroke!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ms. Minden.” He reached out to her, which only made her bolt back in her chair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("killed")]), _vm._v(" him. I don’t know "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("how")]), _vm._v(". But I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("know")]), _vm._v(" they did it!” A tear spilled down her cheek. “And ever since, they’ve done all they could do to discredit me. Make me look like a crackpot. Humiliate me. They planted reviews on my books telling people my books were ridiculous. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Crazy")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mary….” He took a deep breath. “You said that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("patchouli")]), _vm._v(" could keep aliens away. You advised people to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("pray")]), _vm._v(". You said if we loved ourselves that aliens would leave us alone. That tinfoil could keep them from reading our minds.” He pointed at the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Aluminum foil,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Aluminum")]), _vm._v(" foil. Everyone says tinfoil, but they mean aluminum foil. It’s aluminum. Tin doesn’t do shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d barked out a laugh in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She covered her mouth, and this time he knew she was blushing. “It’s ‘fuck’ that I don’t like.” She smiled. It wasn’t pleasant. It was more of a grimace.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("WHILE ADAM")]), _vm._v(" was at the gas station—the “convenience store”—he checked to see if they had aluminum foil. Miracle of miracles, they did, although it cost twice as much as it would have at Sun Fresh or Thriftway.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam bought it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wasn’t sure why he hadn’t called Shane. Told him he was coming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because he would have to explain why he hadn’t called in nearly two weeks. And why he hadn’t answered Shane’s calls. Had ignored the messages.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The one where it sounded like he was crying.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Please, Adam. Please call me.” He was sure he’d heard a sob. “Adam. I-I think I love you. I’ve never loved—” And then the message had cut off and—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God, I’m fucking shit! I’m shit, I’m shit, I’m shit!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Love me? He said he loved me.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("And God. I love him.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He pressed his foot harder on the gas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“BUT EVEN")]), _vm._v(" the aluminum doesn’t work if they have implants inside their heads.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Implants?” Adam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded. She took a deep breath. She touched the scar at her temple.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God, Mary. Are you actually trying to tell me you that you’ve been abducted?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded. “When I was ten. We were camping.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God. Camping….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head. “You think you’ve got an implant in your head?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shook hers. A tear unexpectedly rolled down her cheek. “Not anymore?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Not anymore? “You found someone to look for it? You’re telling me that someone found an implant in you and removed it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” she said, shaking her head. “I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His eyes went wide. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I dug it out,” she replied with a little cry. “With an X-Acto knife.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I dug it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("23")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THERE WAS ")]), _vm._v("one other reason Adam was driving as fast as he could to get to Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wanted to get there before dark.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("24")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HE MADE")]), _vm._v(" it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The sun was still up, but a half hour more? Not so much.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("If he hadn’t been speeding, he would have gotten there after dark. And whether or not Shane was right that the aliens wouldn’t abduct anyone in town, that narrow stretch of road the last twenty miles before Buckman was an entirely different matter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a place he didn’t want be. No matter how wackadoodle the idea was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God, the world had changed in two months.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In two weeks!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He pulled into the gravel drive behind Shane’s house. There was another car there he didn’t recognize beside Shane’s pickup. A red Suburban.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What if it belongs to some guy?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He walked past the garage to the back deck of Shane’s house, and just as he was about to knock on the back double door, it opened.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Both he and the person on the other side gave a little jump of surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The “other person” wasn’t a guy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a woman, with long light brown hair going to gray—same color as Shane’s, he thought, without the gray, of course. Her eyes were the same color as well. He noticed that in an instant. Same brow as well. Almost the same nose, but her face was wider and fuller.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was Shane’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She had smiled as soon as her look of startlement went away. It flashed on her face, broad and wide, not at all like Shane’s. But then it vanished just as quickly. She went rigid. Stood up straight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You must be the boyfriend,” she said stiffly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The boyfriend.")]), _vm._v(" Like it was a nasty word. Hadn’t Shane said she was okay with him being gay?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She looked at him, eyes narrowed, sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh. It’s not that I’m male.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then he said just the right thing. “I hope I’m still the boyfriend. More than you can know.” Sometimes he did that. Said the right thing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Unlike when Shane had said good-bye the previous weekend. Good-bye and I’ll miss you, and Adam had only grunted and nodded and hell, a grunt wasn’t saying "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("anything")]), _vm._v(", was it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But today he must have gotten it right because the stiffness went out of her shoulders and the hard line of her mouth softened, the razor in her eyes dulled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I hope so too,” she said quietly. “But I suppose that’s up to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is it?” he asked and heard the desperate tone in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I still want him. Crazy or not. Cigarettes and sports or not.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs or not.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I figured it was up to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She sighed, and now all the stone in her seemed to be gone. She smiled, although it was nothing like the one she had given him a moment ago. “All he’s talked about is you. For weeks now. And God, how much the last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s heart skipped. “Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her brows came together, bunched up over her long nose. “What you did was shitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The words made him fall back, his heart ache.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t you do it again. If you’re serious about him, then I’ll tell him you’re here. If you’re not, be a man and cut him loose.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m already here,” came Shane’s voice. He stepped out from behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was it possible for your heart to hurt and take wing at the same time?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because Adam’s was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked beautiful, despite the wariness in his eyes. So beautiful. Why hadn’t he ever realized how beautiful Shane was?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can’t believe you’re here,” Shane said. “You hate driving. Why are you here, Adam?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Could Adam dare believe that was hope in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane’s")]), _vm._v(" eyes?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because I believe you,” Adam said quickly, before he could stop himself. “I think I do. I’m scared too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane bit his lower lip.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And I think I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane’s eyes went wide.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam’s heart soared.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do love you,” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For the first time in his life.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Shane was leaping forward to kiss him, and Adam accepted it and more, despite the fact that he’d never kissed in front of someone’s mother before.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think I will leave you two boys to it,” she said and walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But a moment later—Shane’s mouth tasted so good, all mint, no ashtray—Adam pulled (reluctantly) away and spun around. “Mrs. Farmer, wait!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was almost to her car. She stopped and turned around.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I—I would like to talk to you too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("25")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“YOU TOLD")]), _vm._v(" him about that?” Mrs. Farmer said, looking at her son.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked chided. “I tell him everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t be mad at him, Mrs. Farmer,” Adam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shot him a look. “I’m not mad at him. Just surprised. It’s not like I post that kind of thing on the bulletin board at Walmart. People will talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like they don’t already,” Shane laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They were sitting at Shane’s little white plastic table on his back deck. Right where everyone could see them. And then talk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane was actually holding his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Wow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And call me Nora,” Shane’s mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nora,” Adam—the human echo—repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I mean, if you’re going to be my son’s boyfriend and we’re going to talk about them—” She bobbed her head up to the sky. To "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("them")]), _vm._v(". “—I think it’s only right that you use my name. We’ll save you calling me ‘Mom’ until I know you’re not going to run out on him again.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam flinched.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mom!” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What can I say?” Shane’s mother—Nora—replied. “I’m a mother. Been watching out for Shane all his life. It’s not like I can just stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course not,” Adam said, wishing his mother felt the same way. It wasn’t like she hated him. She hadn’t thrown him and Daphne out when she’d discovered their sexuality or anything like that. She was just indifferent. Always had been. She’d actually admitted once (more than once) that she had never quite known what to make of them. Like they were aliens or something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Aliens.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mrs. Far—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nora")]), _vm._v(". Do you think that the… the man in black took you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shrugged. “If he did—if they did—I don’t remember. I don’t remember anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Most people don’t,” Shane said. “Unless they’re hypnotized.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat back, the plastic chair creaking, and sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s probably a good thing,” Nora said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Many of the stories aren’t pretty,” Shane said. “Of what they do to people. Even the Betty and Barney Hill story isn’t happy. They scared the couple. Pretty much terrified them.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Wasn’t it funny that no one needed to know who “they” were? That was the word they kept using. Maybe it was less troubling than “aliens”?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And their story isn’t nearly as scary as some of the others. The Travis Walton incident, the one that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fire in the Sky")]), _vm._v(" is based on, is frightening. The Cash-Landrum case is downright terrifying. Not one of the three witnesses was actually abducted, but they were exposed to high doses of ionizing radiation. Betty Cash stayed in the hospital for fifteen days after the encounter. When Mark Rowtly was abducted, he was panic-stricken, paralyzed. He can hardly remember anything, but because of what he does remember, he will never be the same. If they mean us no harm, then why do some people have such horrifying experiences?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ms. Minden seems to think they’re invading,” Adam replied. He found he just couldn’t use her first name. It was hard enough, considering, to use Nora’s. “I think they drove her a little—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(a lot)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course,” Shane said. “To know what she knows, and there are so few who believe her.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She dug an X-Acto knife into her own head!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did she find anything?” Nora asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She said she did.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Showed me what she found.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She let me see it. She had it in this tiny little glass bottle.” He raised his hand and indicated the size by holding his thumb and forefinger not much more than an inch apart. “It was triangular. The points kind of curved away instead of pointing out. And there were these… I don’t know. Bumps and impressions on the surface. It was red.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Blood red. Dried blood red.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was that the color of the damned thing, or had being inside her turned it that color? If it had actually been inside her head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you believe her?” Shane asked. “That she dug it out of her head?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She thinks so.” Then: “Yes.” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("My God!")]), _vm._v(" “I do. I think I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then another thought came to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane, do you think they put one in you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded again, without hesitation. “I always kind of thought it was in my hand, though,” he said. “Sometimes I think I can feel it.” He took the thumb and first finger of his left hand and squeezed the web between the thumb and forefinger of the other. “But now? I kind of think it might be in the same place as Ms. Minden’s.” He touched the side of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” Adam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The noises,” Shane said matter-of-factly. “You’ve heard them. I know you have. Those high, piercing shrieks?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like an ice pick to the brain,” Adam said with a gasp.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d heard it the day he had first laid eyes on Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I heard it the first time the day we met,” Shane said aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God….” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("So what the hell did that mean, Shane?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think maybe it means we both have one, Adam.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And there it was again! He hadn’t said that out loud, had he? He was sure he hadn’t. Were they reading each other’s minds?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded, and Adam’s eyes widened.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know, like when you stand too close to a speaker when you’re holding a microphone? I think that we both have them. Implants, that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To differentiate from the “them” that meant aliens? Adam shuddered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("God. He was sitting here talking like this was all real.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What a difference two weeks in a life could bring.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think,” Shane continued, “that sometimes the implants—our implants—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God oh God oh God….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("react")]), _vm._v(" to each other.” Shane leaned forward in his chair and rested his chin on upraised, entwined hands. “And I’m wondering…. Maybe we could use that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Use it?” Adam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded. “To get them to leave us alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("26")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("SHANE’S MOTHER")]), _vm._v(" stayed for dinner—helped make it—which turned out to be Hamburger Helper and corn on the side. Not a staple in Adam’s diet, but Shane added onions and green peppers and a can of mushrooms, plus a handful of grated cheese, and it turned out to be surprisingly good.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nora drank a few cans of Milwaukee’s Best (which didn’t say much for Milwaukee) with dinner, and Adam had a Guinness—the last of a six pack he’d left behind the last time he’d been here.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Afterward, he switched to Crown and Coke (also left over from last time), and Shane went with rum and Coke. Nora chose to leave and gave him a hug as she left, which both startled him and made him feel warm all over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t hurt him,” she said. “You know you don’t want to mess with a mother. Much scarier than aliens.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He smiled and nodded and couldn’t believe how good the potential threat made him feel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Like nothing he’d ever really felt except for, to an extent, with his sister. But this was that and more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne would be pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They cuddled on the couch after she left and watched "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mama’s Family")]), _vm._v(" on DVD, and Shane told him how happy—how very, very happy—he was that Adam was here, and Adam couldn’t help but feel embarrassed and amazed and surprised he felt it too. How happy he was to be here.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Despite the fact that he was three hours from the big city.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked up and found himself wishing there was tin foil—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("“Aluminum foil. Everyone says tin foil, but they mean aluminum foil. It’s aluminum. Tin doesn’t do shit.”")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—on the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They won’t come,” Shane said. “Not here. Not where they can be seen.” Despite that, they ran to the local small-town convenience store and bought some patchouli incense sticks—the oil was too much a specialty item even for the Super Walmart—and they burned those, and Adam was touched by the gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can’t believe what I’m feeling for you, Shane.” He was lying back against three or four big pillows (at least), and Shane was resting back in his arms. “I’ve never felt this way about anyone. I’ve never wanted to. I… I’ve been afraid, I guess. I don’t know why. I always have been. Daphne is the only one I’ve even let halfway in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Your sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She’s the one I met at Pride.” It was a statement, not a question.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I like her.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She likes that I’m with you.” Adam smiled. “I am with you, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane laughed. “Yes. I’m with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Adam was thrilled. His heart skipped. The butterflies were back. He really couldn’t believe he was with someone. “You’re so different,” he marveled aloud. “There are things about you… things on my absolutely no-way list. And yet I don’t care.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The cigarettes,” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” Adam said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I haven’t had one in a week. Combined with my asshole boyfriend not calling me, it’s been hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam didn’t know how to react to either of those sentences or all that they said. He was a bit stunned. Shane hadn’t smoked in a week?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Over a week. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Boyfriend?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ve established that, haven’t we? You’re my boyfriend?” Shane rolled over and rested his chin on crossed hands atop Adam’s chest. “At least now?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Adam did another double take.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had happened again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did you just read my mind?” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave the slightest shrug. “I think I did. Kind of. I think it’s happened before.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do too,” Adam said, and this time, it was even quieter than a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wow,” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded. Wow, indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is real.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked back up at the ceiling. Forced himself not to. His eyes met Shane’s. Met Shane’s beautiful eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Real.")]), _vm._v(" This "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("is what is real.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And this was what was really important, no matter what else was going on. No matter what else could go on.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("This was what needed taken care of.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I am so sorry, Shane. For what I did. It was mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane gave a nod. “Cruel, even.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That hurt.” It did. But he deserved it. And he told Shane that he deserved it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t do it again, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wouldn’t. No way.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I believe you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Again. Shane had done it again. It was a little unsettling. But Shane believed him. And that was what mattered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I read online that for most people, the worst of the nicotine withdrawal is only supposed to last a few days. A couple weeks at most. I think the asshole who wrote that never smoked.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“An asshole like your boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane smiled. “Just like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam couldn’t remember being so happy. Even with the worry that Ets could be waiting for him. With Shane at his side, anything was possible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Now if I can just get him to stop watching baseball, things will be perfect.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane raised an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh, shit.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“May I ask you something, Mr. Brookhart?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam swallowed hard. Nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you think you’re somehow perfect? With your prejudice against small-town life? The town "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I")]), _vm._v(" love? The home I love? How do you think it makes me feel that you hate baseball? I love baseball, Adam. Love it. If you understand it or not, I do. I’ve fantasized all my life that the person I fall in love with would spend a lifetime going to games with me. I have this dream to see a game in each of the thirty major league ballparks—which is pretty out there considering it makes me nervous to leave Buckman. But with a boyfriend at my side, it could be an adventure. And having you as my boyfriend would mean I’d have to give that dream up. And I’d do it for you. Because I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("do")]), _vm._v(" love you. A lot. And just because you believe that baseball is dumb and boring, that doesn’t mean I do. In fact, it kind of hurts my feelings.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was all Adam could do to keep his mouth from falling open.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Fuck.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was almost like a slap.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Am I that big a fucking shit?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("And did he just hear that?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And we haven’t even begun to talk about the problems we’re going to face being together. We live three hours apart. And I think it’s pretty clear you don’t really want to live here. In the house that I love. In Buckman. And baby, I don’t want to live in a cramped little apartment in Kansas City. One of us is going to have to give up our home if we’re going to live together instead of just spending weekends together. I want more than that. Don’t you? I want more than a weekend lover.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now Adam’s mouth did fall open. He was speechless.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And his heart ached.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because he did want more than a weekend lover. A lot more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“In the meantime….” Shane turned on his side and shoved back against him. Adam had to turn on his side so there was room. But then Shane wiggled so his butt was even closer. Was pressed up against Adam’s crotch.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t do that, baby.” He could already feel his cock responding.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know why not,” Adam said. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Because I’ll want you. I want you already.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then Shane sat up. He sat up and looked down at Adam. Adam’s heart started to pound. Those eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I want to try,” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“T-try?” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Try what?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then he saw it in his mind. Saw what Shane meant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh God.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you sure, baby?” Now his heart was really pounding.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Very sure,” Shane said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("27")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("AFTER THAT")]), _vm._v(" they went to bed, and it was sweet. Not like anything Adam had ever experienced.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you sure?” Adam asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane kissed him by way of an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They held each other. They touched each other. Kissed each other. Everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam made love to Shane’s beautiful bottom the way he’d wanted to since that day he saw him standing next to his picnic blanket. Standing there wearing those blue-and-white plaid shorts that had done nothing to hide his round, firm ass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He took his time. Covered those mounds with kisses and licks and tiny nibbles. He slowly nudged his face between them. Ran his newly bearded face in that tight cleft.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And thank God, Shane moaned through all of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he found Shane’s hole, his lover flinched for just a second and then relaxed. Adam could feel the trust. In his heart and in his mind, he felt it. Normally he might have attacked it. This night he took his time. Kissed it. Licked it. Made love to it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane cried out over and over, was practically sobbing and telling him how wonderful it was and how good his beard felt “down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam, urged on and feeling things he’d never felt before, made love to that tight little coil of muscle, and slowly but surely it relaxed and let him in.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was glorious.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Slowly but surely he worked a finger inside, telling Shane that he loved him all the time he was doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Slowly but surely it became two fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And when he was ready to try for something more significant, when he was sure he might only last a second before he came he was so excited, wanted Shane so much, Shane stopped him. Rolled over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“This way,” he said. “I want to see you. See "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("you")]), _vm._v(". Know it’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("you")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And that truly was what it was all about, wasn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If they have invaded their victim’s bodies,” Ms. Minden had said, “how easy can it be for the abductee to allow anyone inside them?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And so he held Shane and told him over and over that he loved him—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("(because he did)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("—and he took forever to find himself inside his lover, and he was slow, so slow, and it really was unlike anything he had ever experienced.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("More than sex. It was making love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then when Adam could hold back no more, and God, when Shane’s eyes rolled back and he began to ejaculate between them without ever touching himself, Adam came like he never had before.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was glorious.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And holding each other, after, something hit him. Something Daphne had said to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ve always had troubles with relationships, with trusting anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And on the tail of that….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Something that many abductees have in common is the same with many rape victims,” Ms. Minden had said. “Abductees have trouble with relationships, with trust, with sexuality and their own bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("My God")]), _vm._v(", he thought. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s me.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("28")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("BUT AS")]), _vm._v(" Adam was falling asleep, he couldn’t help but look at the ceiling. Wish for aluminum foil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’re okay,” Shane assured him. “They won’t come.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay,” Adam said, and he snuggled tight to his lover and hoped Shane was right.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("29")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("BUT HE")]), _vm._v(" wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They came.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("30")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("AT FIRST")]), _vm._v(" Adam took it all as if nothing were unusual.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Like a dream where you never questioned why you were sitting on the porch with someone who had died years and years ago, but it didn’t seem the least bit peculiar.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or living in a tree house like the Swiss Family Robinson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Married to Chris Evans and both of you were on the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ellen")]), _vm._v(" show.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And finally you began to realize that maybe this wasn’t real….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because you didn’t slowly float out of bed and go drifting down the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Windows didn’t open by themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("You didn’t float out of them and drift up to a dark shape barely visible against a night sky where the only thing to indicate it was there was a lack of stars.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("You didn’t wonder why you weren’t afraid of the manlike shapes around you. Manlike except that their arms and legs were stick thin and their heads were huge and oblong and the only face you could see was ominously large, slanted almond-shaped eyes. You didn’t remember that these gray beings were exactly what you had been afraid of. For some reason you were fine with it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam went through all this.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The accepting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then the noticing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The wondering.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The thinking that this might be a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And slowly, slowly realized that it wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He quite suddenly remembered the night on the lake. Following Skip into the water, embarrassed by his throbbing erection. His friend hadn’t seen it—or noticed his confusion about why his penis was behaving like that. Wasn’t that only supposed to happen about girls? They’d waded until the water was at their necks and then begun to slowly dogpaddle out and then tread water and then…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s that?” Skip asked and brought an arm out of the water long enough to point at the sky over Adam’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked, and at first he thought Skip meant the moon and was just joshing with him, but then he saw there was a shape just to the right. The full moon’s light was silhouetting it, and it was disklike, but there was some kind of mechanical-looking arm sticking out of the left side. It looked like a helicopter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a helicopter,” Skip said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But it wasn’t. Adam saw that without a doubt, because there was no rotor, just the mechanical thing jutting out the side of whatever that was hovering up in the night sky.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. Not hovering.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was moving. Moving very slowly, and as it did it came in front of the face of the moon and Adam could see an identical arm on the other side of the… the…. What was it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then red lights, one on either side, began slowly blinking at the ends of the arms. The disk, again slowly, began to glow with blue-white light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was getting closer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I wanna go home,” Adam said and realized he was almost crying, and Skip agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let’s get out of here,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They swam as fast as they could to the shore, Adam crying all the way, and as they climbed out of the water—Adam’s erection was a thing of the ancient past—they didn’t even reach for their clothes. They ran.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The craft, because that was what it was of course, quickly reached them. The lights along its sides, as well as the blinking red lights at the end of the helicopter-like arms, went out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("They don’t want anyone to see….")]), _vm._v(" And how Adam knew that, he had no idea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was flying so low Adam couldn’t understand why it wasn’t hitting the trees. He was crying. He couldn’t stop. And then came the light. A single misty white beam shone down on them, and Adam turned to his friend—his brave friend who was openly crying now as well—and they were floating.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Adam,” Skip shouted but didn’t shout. “Make it stop!” His voice was muffled somehow. It was like Adam was listening to his friend while holding pillows tightly against his ears.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("They don’t want anyone to hear us!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The bottom of the craft had opened, and they rose and rose until they were inside. Then the door, or whatever it was, screwed closed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam could hear his friend clearly now, sobbing and telling him to “make it stop!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But how could he?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The men came to them then. Small men, not much taller than the two of them, and they were gray and their skin was shiny, like plastic, and they had huge unblinking black eyes and then…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when the terror began.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("31")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM WANTED")]), _vm._v(" to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The darkness in the sky opened up, and there was a door filled with bluish light. The only light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was no huge orange ball like in some of the abductee accounts he had seen. Like in that book…. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("UFOs Caught on Film")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No blinking lights either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No lights beneath or along its surface.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No windows with slant-eyed beings looking out at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Only that door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Like before! Oh God, it’s real! It’s fucking real, and it has happened before.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("More than once.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And maybe, just maybe, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("many")]), _vm._v(" times.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he was going through the doorway. Going down a corridor, and he couldn’t see Shane. Where was Shane?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane!")]), _vm._v(" he screamed. Screamed with his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam was floating on his back, as if on an invisible stretcher, and when he lifted his head, he could see the three “men” ahead of him, but not Shane. He looked to the left and right, and there were three more of these men.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He smelled cinnamon. Of course he did. He’d remembered it from before, and he hadn’t been able to stomach cinnamon rolls since he was a kid—which infuriated his mother, who made the Pillsbury ones many a Sunday as he was growing up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They all looked the same, those others.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Exactly the same.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Their skin was gray and shiny and perfectly smooth. Their heads were large, their unblinking black eyes like polished stones.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a magnetic stone,”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("Ms. Minden had told him, clutching at her necklace."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("“They… don’t… like… magnets….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He so wished he had a magnetic stone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam longed to look behind him. Because he was sure that if he could, he would see three more of the men.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was in all the books.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Books by Whitely Strieber and Kathleen Marden and Mary Minden.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Threes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam knew if he could look behind him he would see his lover and three more men. Greys, not men.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They came in threes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And they looked at you with big unblinking eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("How could those eyes not blink? Didn’t they need to blink? Blinking did something, for God’s sake. Kept the eyes moist or something. Kept them clean!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s what ")]), _vm._v("we"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" need.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Who knew if "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("they")]), _vm._v(" needed the same thing?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Who knew how their eyes worked?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane!” he cried. Or tried to. There was something wrong with his mouth. He couldn’t scream. He couldn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So he used his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Because Shane had heard him before. Maybe he could hear him again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane")]), _vm._v(", he thought. Thought as hard as he could. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m here")]), _vm._v(", came Shane’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What do we do?")]), _vm._v(" he thought back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For the longest time, there was no answer. He wanted to panic. Because for some reason he thought—he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("knew")]), _vm._v("—that Shane would know the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("We wait")]), _vm._v(", came the sudden reply.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And as much as waiting scared him, he decided to trust Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was filled with warmth then. A warmth a thousand times better than being "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("inside")]), _vm._v(" his lover. And he’d never felt "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("anything")]), _vm._v(" like that before.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you")]), _vm._v(", came Shane’s mental voice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was brought into a room, and good God, all the stories were true. The room looked like an operating theater. There were long, slim tables that stuck out from the walls—walls that somehow glowed blue. There was light above the tables, and they glowed blue (but much more brightly) as well.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you")]), _vm._v(", he thought back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There were machines above the beds. Mechanical arms and bars and poles and more. He floated toward the bed and then above it, and then he was drifting down onto it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Three of them came around the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Three.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And for some reason, he was terrified.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Unblinking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The machines began to move. One of the mechanical arms shifted, lowered, and then a long needle came out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No no no no….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then it was sticking down into his navel, and it was horrible. Excruciating!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No! Why are you doing this to us!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he remembered what Ms. Minden had said. “I believe these beings are much more advanced than us, so ahead of us that they don’t even consider us to be much more evolved than monkeys. Think on it. When we capture animals in the wild, then tag them, then release them again—do we explain to them what we are doing to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. Of course they didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do we say ‘sorry, Mr. Bear, we’re doing this to track your behavior’? When we tag tigers to see about their migratory habits, do we tell them what we’re doing? Or sea creatures. Do we tell them we are just trying to learn about where they travel in the ocean? Of course not!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Of course not!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("that")]), _vm._v(" is what is happening with these beings. They don’t explain what they’re doing to us. They wouldn’t even be "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("able")]), _vm._v(" to explain. They don’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("think")]), _vm._v(" to explain. They don’t consider us… human, for lack of a better word. They probably consider us only barely sentient.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Barely sentient! They barely consider us sentient! And what do they want from us?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“To "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("study")]), _vm._v(" us. There is something they want to know. Something that makes us different from them and they want to know what it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But what was it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Did it even matter?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All that mattered was that these being were treating him as less than human. And worse. Treating Shane as less than human. And that he couldn’t allow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane!")]), _vm._v(" he shouted with his mind. With all the strength he had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had to fight. He "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("had")]), _vm._v(" to. But how?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then he had an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("32")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HE TRIED")]), _vm._v(" to raise his arms, tried to form fists, but he couldn’t. Somehow they were preventing him from moving. Maybe through an implant? The books said they could control minds. Had Ms. Minden said something about that? He couldn’t remember anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So then what?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Emotional defense. That is what her book said. Anger. And God, he was angry!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He tried to shout and saw he couldn’t even do that. Not physically. Not with his mouth. But with his mind?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("With his emotions?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Stop it! You’re hurting us!")]), _vm._v(" He shouted it with all of his mind. Screamed it. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Leave us alone!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To his surprise the creatures staggered back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That and more, you fuckers!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What was next?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Love?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Self-love, he remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And what could he do with that? Nothing. Not now. Because all he could think about was Shane. Shane, who had gone silent. What had they done with him? Done with the first person he had ever really loved?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Baby!")]), _vm._v(" he shouted with his mind. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m here! I love you!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now several of the Greys put tiny hands on sticklike arms to either side of their heads. Several of them moved away. Fast.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when he saw Shane. He was on the table next to Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane! My God, Shane! Are you all right?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For a moment, nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then Shane moved!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane turned his head to face him. Looked at him with eyes filled with fear. Shane. The one who knew all about this shit. The one who had told him there was nothing to fear. The one who had been brave.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay,” he said. Aloud. He’d said it out loud!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane, I’m here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane’s mouth opened. Closed. Opened. But nothing came out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It’s okay")]), _vm._v(", he thought to Shane. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you.")]), _vm._v(" He reached out to his lover.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Shane. He was reaching back!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Their fingers touched then. Interlocked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Love you")]), _vm._v(", they both thought at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when everything changed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("33")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("LOVE.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a voice in Adam’s head. But it wasn’t his own.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Love?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then the Greys were there again. Standing over him. Looking at him with those big black unblinking eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Love?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They were talking to him!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” he managed to say. “Love. Do you "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("things")]), _vm._v(" know what love is?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then one of them nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes")]), _vm._v(", came the response inside his head. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("We do.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One of the Greys moved up between them. Looked at their clasped fingers. Then at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You are both male.")]), _vm._v(" It wasn’t asking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then it glanced directly at his penis. Then…. Then at Shane’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then it began to undress.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("34")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("UNDRESS?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. Not exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Once, when Adam was a kid, he’d seen a cicada coming out of its skin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was what this looked like. The Grey was folding in on itself. Bending forward. And something was coming out of its back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was pink. Darker than pink, but not red.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bit by bit, it pulled itself out of the back of its….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A head popped back out of the grayness it had been in. A head with small blue tiny eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They blinked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then the others began to do the same thing. The Greys. Who were not gray at all. They were a color somewhere between pink and red. What color did you call that?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For a moment Adam wanted to scream. But then it blinked again. The others were pulling themselves out of their suits as well. Suits. The shiny gray creatures weren’t flesh—it wasn’t… them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They were suits.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Spacesuits")]), _vm._v(" came Shane’s voice inside his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Spacesuits.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The machine’s arm raised into the dark recesses of the room. The force that had been holding him immobile was gone. He could move.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he did.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sat up and saw Shane doing the same. He scrambled off the bed and went to Shane’s side. “Baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane wrapped his arms around Adam and pulled him tight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That was when he saw it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The Greys—or Pinks?—had a whole new surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("35")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ADAM WOKE")]), _vm._v(" to sunlight streaming in between the curtains of the bedroom window. He stretched and yawned and then smelled the coffee. He hoped there was some left.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("As per his usual style, he didn’t bother to put anything on, but after climbing out of bed naked, he left the bedroom and found Shane in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Surprise. He was writing in one of his journals. He’d only seen Shane doing that one other time….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For some reason the memory caused him to flinch the slightest little bit. He decided to ignore it for this wonderful and somewhat fuzzy morning. He felt a little… what? High? Had they had a lot to drink last night? He couldn’t really remember if they had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There were a few empty beer bottles in the trash.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Morning, babe,” he said and went to Shane to give him a kiss. His morning wood, not a semi, bobbed a bit before him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked up from his writing, a smile on his face, and then did a double-take at Adam’s erection. “Well good morning to you,” he said with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To Adam’s happiness, he saw there was coffee in the pot. It was almost full. Had Shane just gotten up?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup,” Shane replied, attention back on whatever he was scribbling in his journal. “The coffee’s fresh. I used that kind you like so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The Shepherd’s Bean. The Yirgacheffe! Oh God, yes. So much better than what Shane usually….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You are such a snob,” Shane said, shaking his head. “We discussed that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam poured, sat, and leaned in for a kiss. “Sorry,” he said with a chuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane rewarded him with a look from those beautiful eyes and a sweet little kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What are you doing?” he asked. “If it’s not private.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not private,” Shane said, still writing. His hand was moving across the pages quickly. As if he had a lot to say and wanted to say it as fast as he could. “I’m just trying to get it all down. I’m afraid I’ll forget. And I don’t want to forget any of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Forget? “Forget what?” he asked, curious. Was he writing about the sex they had last night? Oh God! What sex! He didn’t want to forget either. Ever.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Except for maybe the beginning. I didn’t like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam jerked ever so slightly. Shane didn’t like the beginning? Why, Adam had thought it was all sweet. The best lovemaking he’d ever experienced. Maybe the only real lovemaking. It had all been just sex before—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked up from his page. “I’ve never remembered any of it before, Adam. I always knew, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("knew")]), _vm._v(", that it happened. And for the first time I can remember. But what if it goes away, baby? I can’t stand the idea. So please, let me get it down first.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Huh?” What was he talking about? “I don’t want you to forget either, baby. I don’t want to forget either. It was the best….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Blue light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam jerked again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Unblinking black eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam jerked in his chair, so hard this time he almost fell over backward, and he spilled half his coffee, most of it on his hand. He hissed and brought it up to his mouth, sucking at the burnt spot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane had stopped writing. “Baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh my God….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He saw them then. Coming out of the backs of those shiny all-the-same gray suits, like cicadas breaking through the backs of their shells—their skins.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh my God….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Saw")]), _vm._v(" them. Saw the Greys. Saw them for what they were….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Baby?” The look of concern on Shane’s face was enough to jolt him back to the here and now, the seat he sat on, the kitchen he was in, the man he was with.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane reached out and took his burnt hand—not too burnt—and—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Wham!")]), _vm._v("—it all came back. All of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh my God….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("36")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE GREYS")]), _vm._v("—now some other color entirely—were all male.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Trying to understand")]), _vm._v(", came its—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("his")]), _vm._v("—voice in Adam’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Such a curious race. Nothing else like you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Its eyes were small. Nothing like the famous, large, unblinking slanted oval eyes from modern legend. From the cover of "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Communion")]), _vm._v(". From dozens of movies. But they were certainly as black.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And its—his—skin…. What color did you call that? Not pink. Not orange. Salmon? Coral? In fact, it reminded Adam a lot of the aliens from "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fire in the Sky")]), _vm._v(", but not as… mean. They were softer. Surprisingly less scary.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At least now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was no nose. Not that he could see—could "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("remember")]), _vm._v(". The mouth was very small, just like the stories, and it didn’t move. The lips didn’t move while it “talked” inside his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The head was very large for its body, which was overly slim, with long, almost sticklike, arms. The legs were just as thin, but much shorter than its arms.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("His!")]), _vm._v(" He had to think of the being as a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was important.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But why?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Male.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("What lay between his legs was not a penis, not anything human, that was. More like… what? A dog? More than a bump, but nothing hanging.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They all had them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All of them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Three sets of three stood around Adam and Shane. Another triad was moving slowly into the room. All their faces bore curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Such a peculiar race.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” Adam asked. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Why")]), _vm._v(" are we peculiar?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("So different than anywhere else.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How are we different?” "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("God. I’m talking to them. They’re talking to me.")]), _vm._v(" “Why different?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("So different than the other species on your world.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How?” Calm. Keep calm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane moved even closer to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The other creatures… they procreate during… seasons.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seasons?” Adam asked. “What do you mean….?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like going into heat?” It was Shane’s turn to ask. “Is that what you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The alien nodded. Interesting to see it use such a human gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes. When it is time to procreate, the female becomes ready. This makes the males ready. They mate. Then they are done. Often going their separate ways. Or at least not mating again until the female… goes into heat once more.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I—I guess,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("But unlike the other animals on your planet, your species stands alone as sexual even when it is not time to procreate. The two. They mate! They form permanent bonds. Not like us or even as so many others out there.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It took a long hand and gestured above it. Around it. Everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” Shane replied. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Out there….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Curious. Strange. We don’t understand. So different. How this works… we don’t understand. How your species…. For some reason the norm is for the opposite sexes to bond, but not those of the same sex. How can it be that only the opposites sexually bond. Throughout the universe this is not the way. Those on other worlds bond in any combination. Only here is opposite-gender bonding the norm.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m… I’m not sure I understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another of the Pinks came up behind and beside the first one. It laid a hand on the first one’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes. Yes, you do. You are more like us. Except there are only two of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A third came up on the other side. He placed his hand upon the first one as well.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("We are three. It allows balance. It is stronger. It manages. Creates order.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait,” Adam said and marveled that his fear was gone. He was standing here with Shane—his lover—in the midst of these otherworldly creatures, and he was no longer afraid. And he thought he might be beginning to understand. “You three.” He nodded at the trio standing before them. “You’re mated.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes")]), _vm._v(", came the response. And somehow he knew it was all three of them answering.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh wow,” said Shane. “And you’re all male.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Of course. We are the same. How does your species do it? We’ve been trying to understand for so long.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Dear God")]), _vm._v(", thought Adam and looked at his Shane. “They’re all… homosexual?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Homo-sexual. Same-sexed. The same. The same understanding. The same. Of course. The way it is for us. Our species, what you call “Greys,” our bonds are… ")]), _vm._v("homosexual"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" only. We are not considered the “norm” either. Most species bond in a way that seems haphazard to us. But somehow, ")]), _vm._v("some"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" species, as with yours, the males and females bond beyond mating. Beyond procreation. And we do not understand.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll be fucked,” Adam said. God.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("But you…. A few times we have found those of you that are like us. The two of you are not like most of your species. Both male. The same. The same understanding. Male and male. For when you are not procreating. A bonding ")]), _vm._v("we"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" understand.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam shook his head, astonished. “You’re gay.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The eyes showed… curiosity. He saw that it was trying to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re saying,” Shane asked, “that out there in the universe, most other species are bisexual?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bisexual?")]), _vm._v(" came the inquisitive reply.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bisexual,” Shane repeated. “That most lifeforms can form any combination of… bonding? Coupling up?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Most, yes. Not all. There are a few of us that always bond… homosexual. And we… we are male to male to male. Female to female to female")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“As trios,” Adam said. It was not a question. “Triads.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The alien gave a nod. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Of course. Because there is understanding in sameness.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who raises the children?” came Shane’s next question. “You "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("do")]), _vm._v(" have children.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Procreate. Of course. To continue the species. The males raise the male offspring. The females raise the female offspring. The same. This is logical. This makes sense. And somewhat like most species on your world, we only come together with opposites when we are sexually fertile.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam could only shake his head. Unbelievable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("But today we find you. You two are more like us. You two make sense to us. You are the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hardly!” Shane said with a bark of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Same enough. And if there were three of you, that would bring balance when there are clashes. The third always bring negotiating. Mutual understanding and acceptance.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think two is challenge enough,” Shane said. “Adam?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam agreed. “More than enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("There is so much we do not understand. We haven’t meant to… harm. We have only been trying to understand you. And it was only a… force between you… that surprised us. Made us… more aware that there was some kind of bond between you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bond?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh God")]), _vm._v(", thought Adam. “Do you mean love?” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The alien nodded. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Love.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wow” was Adam’s only response.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Are there more of you? We think we have encountered a few more.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“More couples of the same sex?” Adam nodded. “Yes. But it’s only now becoming accepted. In our country at least. Some others. But there are places where it’s a crime. People die for loving their own sex.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The alien winced. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Insanity.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded. Insanity indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("There is still so very much we don’t understand. So much we want to understand.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good luck,” Shane said. “We are a pretty weird group.” He nodded toward Adam. “Especially him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shane!” Adam laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Weird?")]), _vm._v(" the alien asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t worry about it,” Adam said and laughed again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("We want to know more.")]), _vm._v(" This was a new voice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They turned, and a much taller being stepped into the room. It was no longer wearing a black trench coat. Or a hat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And it looked very much like a praying mantis. Its mouth parts worked, eyes blinked, short antenna bobbed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("So much more. So many questions. With ")]), _vm._v("us"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" there are only a few females to every male. One for hundreds.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Like bees, ")]), _vm._v("thought Adam"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(". Not like a praying mantis after all.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("This is normal for exoskeletal species, ")]), _vm._v("it, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("he")]), _vm._v(", said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Insectoids. And now the memory of them came as well….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, we’re right here,” Shane said. “We’ll try to help. We’ll answer any questions you have.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Shane")]), _vm._v(",” Adam said and pulled his lover all the closer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane looked at him, determination showing in his eyes. “We have to,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sighed. Turned back to the creatures. The aliens.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But you can’t keep doing it the way you’re doing it,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You can’t keep hurting people,” Shane added. “Poking them. Prodding them. It’s an invasion. Ask us. We’ll help.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("We are asking")]), _vm._v(", said the triad then. And Adam knew it was all three asking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s all you had to do,” Shane replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("37")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THEY SAT")]), _vm._v(" and drank coffee, and then they dressed and took a long walk and had lunch and sat on the back deck and even called Shane’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They wrote and wrote and wrote in Shane’s book.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They shared all they could remember… and then they remembered more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam called Ms. Minden, who was stunned at what he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A book,” she said. “You’ll help? I’ll need your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam laughed. Help her write a book. Tell his story? His and Shane’s story?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Was the world ready to find out that bisexuality was the norm in the universe? Except for the famous Greys, who were entirely gay and couldn’t understand anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He laughed all the more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Did he care?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes")]), _vm._v(", Shane thought. “We care. It will change the world. Gay people knowing what we have to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No one will believe us,” Adam said. “If we help her—if we tell our stories—no one will believe. We’ll be laughed at. Ridiculed. The debunkers will attack our every word. Just like Travis Walton or Betty and Barney Hill. How many people will believe?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Does it matter?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Did it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can we think about it?” Adam replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane rolled his eyes. “Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And that’s what Adam told her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“In the meantime, what about us?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What about us?” Adam answered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ve got a lot to figure out if we’re going to make this work.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded. “We’ll figure it out,” he said. “We’re worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane kissed him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And they began to figure it out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("38")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“ALIENS,” DAPHNE")]), _vm._v(" said flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She looked at him. Then at Shane.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And then she gave a single nod in response. No emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No. Wait. Something. He saw something. She had cop face. But she’d been his sister for thirty-two years. She couldn’t hide from him. There was something. But he just didn’t have any idea what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Daphne sipped her Buena Vista honey process, La Palma y El Tucán, direct trade from Colombia. They were all at The Shepherd’s Bean. Daphne, who hadn’t been bugging him too much for answers. Who had simply been thrilled that he and Shane were together.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had taken him two weeks to tell her what had happened. And now he was trying not to piss his pants.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You believe me? "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Really")]), _vm._v("? But it’s so crazy….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She looked up. “I was the one who told you not to close "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("your")]), _vm._v(" mind, wasn’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I….” He closed his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then: “Stranger things.” She gave him another single nod. “Stranger things under heaven and earth that you can dream of.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“My God,” he said. “You really do believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I said it before. You won’t believe the things "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’ve")]), _vm._v(" seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You gonna tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She took another drink of her coffee. Looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam thought she was never going to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam had just given up when she said, “Do you remember the Voodoo Killer last year?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Voodoo?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“People getting their hearts cut out…?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he remembered. “Oh yeah.” God yeah…. “But didn’t it turn out to be some kind of Christian fanatic?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That doesn’t mean it wasn’t real,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do you mean real?” Shane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Voodoo spirits. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Vodou")]), _vm._v(" spirits….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam looked at his sister in surprise. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Spirits")]), _vm._v("?” What the hell…?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane put a hand on his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Listen to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Inside Adam’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sometimes he could still hear his Shane’s thoughts. Sometimes Shane could hear his. Especially when he’d been drinking a bit. When doubts and reason could be cast aside—because even after all he’d been through, there was still that part of him that wanted to shout, “This isn’t real!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked at Shane and felt a delightful tingle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I love you")]), _vm._v(", he thought back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Shane smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam turned back to his sister. Yeah, okay…. “Stranger things?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She lifted one of those perfect eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It all started when I met this reporter named Taylor Dunton and Myles, a vodou houngan….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Stranger things….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("39")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HIGH ABOVE")]), _vm._v(" them, the alien Greys waited.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And watched.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And learned.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0